/* Oaktone Backstage (sections/stage-tools.liquid). Reads an Oakboard over Web MIDI,
   checks its firmware against the oaktone-firmware Space, programs button assignments,
   shows a MIDI monitor, and runs the TrueTap tap tempo engine as a MIDI clock master. Settings arrive from the section as JSON in #stage-tools-config. */
(function () {
  'use strict';
  var root = document.querySelector('.oaktone-stage-tools');
  if (!root || !window.Promise) return;
  var CONFIG = {};
  try { CONFIG = JSON.parse(document.getElementById('stage-tools-config').textContent) || {}; } catch (e) { CONFIG = {}; }

  /* =====================================================================
     1. FIRMWARE LIBRARY
        A DigitalOcean Space holds one zip per release, named like
        FloorVistaFirmware2.0.1.zip. The page lists the Space, sorts the
        files by model and hardware, and offers the newest one. Nothing
        else to edit when a release goes out.
     ===================================================================== */
  var LIBRARY = {
    list: (CONFIG.listUrl || 'https://oaktone-firmware.nyc3.digitaloceanspaces.com/').replace(/\/?$/, '/'),   // listing (plain endpoint; the CDN doesn't list)
    base: (CONFIG.downloadUrl || CONFIG.listUrl || 'https://oaktone-firmware.nyc3.digitaloceanspaces.com/').replace(/\/?$/, '/'), // downloads
    prefix: CONFIG.prefix || '',
    usbcFrom: (function () { var m = /^(\d+)\.(\d+)(?:\.(\d+))?$/.exec(CONFIG.usbcFrom || ''); return m ? [+m[1], +m[2], +(m[3] || 0)] : [1, 9, 0]; })()
  };
  var PAGE_NAME = CONFIG.name || 'Backstage'; // the Shopify page title, so a rename never touches this file
  var SUPPORT_EMAIL = CONFIG.supportEmail || 'support@oaktone.com';
  var HELP_URL = CONFIG.helpUrl || 'https://help.oaktone.com/';
  var FILE_RE = /(?:^|\/)(?:Oakboard)?[-_ ]?(FloorVista|Floor[-_ ]?Vista|SlideDuo|Slide[-_ ]?Duo|Mini2?)[-_ ]?(?:Firmware)?[-_ ]?v?(\d+)\.(\d+)(?:\.(\d+))?(?:[-_ ]\d{4}[.-]\d{2}[.-]\d{2})?\.(zip|hex|bin|dfu)$/i;

  var MODELS = {
    OF: { code: 'OF', name: 'Oakboard Floor Vista', short: 'Floor Vista', file: /floor/i,
          buttons: ['prev', 'next', 'play', 'stop'], shift: false, faders: 0, cols: 2 },
    OM: { code: 'OM', name: 'Oakboard Mini', short: 'Mini', file: /mini/i,
          buttons: ['prev', 'open', 'next', 'play', 'reset', 'stop'], shift: true, faders: 0, cols: 3 },
    OS: { code: 'OS', name: 'Oakboard Slide Duo', short: 'Slide Duo', file: /slide/i,
          buttons: ['prev', 'open', 'next', 'play', 'reset', 'stop'], shift: true, faders: 2, cols: 3 }
  };
  var HW = {
    usbc:    { label: 'USB-C board', install: 'loader' },
    teensy32: { label: 'Teensy 3.2 board', install: 'zip' },
    teensy40: { label: 'Teensy 4.0 board', install: 'zip' }
  };

  var LOADER_URL = CONFIG.loaderUrl || 'https://oaktone.com/loader'; // fallback when the Space has no Loader build listed
  var library = { files: [], loader: { mac: null, win: null, version: null }, source: 'none' };
  var LOADER_RE = /(?:^|\/)Oaktone[-_ ]?Firmware[-_ ]?Loader(?:[-_ ]?v?(\d+(?:\.\d+){0,2}))?(?:[-_ ]?(mac|macos|osx|win|windows))?(?:[-_ ]?(?:x64|arm64|universal))?\.(dmg|pkg|zip|exe|msi)$/i;

  function parseVersion(str) {
    // Accepts 2.0.1, 1.74 (short form), 1.9.4.2 (build suffix ignored) and 1.9.1L (old "L" builds).
    var m = /^(\d+)\.(\d+)(?:\.(\d+))?(?:\.\d+)?L?$/i.exec(String(str).trim());
    if (!m) return null;
    var a = +m[1], b, c;
    if (m[3] === undefined) { // "1.74" written the short way
      if (m[2].length === 2) { b = +m[2][0]; c = +m[2][1]; } else { b = +m[2]; c = 0; }
    } else { b = +m[2]; c = +m[3]; }
    return [a, b, c];
  }
  function vstr(v) { return v.join('.'); }
  function cmp(a, b) { for (var i = 0; i < 3; i++) { if (a[i] !== b[i]) return a[i] - b[i]; } return 0; }
  function hardwareFor(v) {
    if (cmp(v, LIBRARY.usbcFrom) >= 0) return 'usbc';
    return v[2] % 2 === 0 ? 'teensy32' : 'teensy40';
  }
  function modelForFile(word) {
    if (/floor/i.test(word)) return 'OF';
    if (/slide/i.test(word)) return 'OS';
    if (/mini/i.test(word)) return 'OM';
    return null;
  }
  function parseLoader(keys) {
    var out = { mac: null, win: null, any: null, version: null };
    keys.forEach(function (key) {
      var m = LOADER_RE.exec(key); if (!m) return;
      var os = !m[2] ? 'any' : (/^mac|osx/i.test(m[2]) ? 'mac' : 'win'), v = m[1] ? parseVersion(m[1]) : null;
      if (!out[os] || (v && (!out[os].v || cmp(v, out[os].v) > 0))) out[os] = { url: LIBRARY.base + encodeURI(key), v: v };
    });
    var v = (out.mac && out.mac.v) || (out.win && out.win.v) || (out.any && out.any.v);
    out.version = v ? vstr(v) : null;
    return out;
  }
  // A build named for one OS wins; otherwise a single unlabelled Loader download serves both.
  function loaderLink(os) { var l = library.loader[os] || library.loader.any; return l ? l.url : LOADER_URL; }
  function loaderIsSingle() { var L = library.loader; return !L.mac && !L.win && !!L.any; }
  function loaderButtons(cls) {
    if (loaderIsSingle()) return tbtn('Download the Loader', cls || '', library.loader.any.url);
    return tbtn('Loader for Mac', cls || '', loaderLink('mac')) + tbtn('Loader for Windows', cls || '', loaderLink('win'));
  }
  function parseFiles(keys) {
    var out = [];
    keys.forEach(function (key) {
      var m = FILE_RE.exec(key); if (!m) return;
      var model = modelForFile(m[1]); if (!model) return;
      var v = parseVersion(m[2] + '.' + m[3] + (m[4] !== undefined ? '.' + m[4] : '')); if (!v) return;
      out.push({ model: model, v: v, key: key, ext: m[5].toLowerCase(), url: LIBRARY.base + encodeURI(key) });
    });
    return out;
  }
  function newestFor(model, hw) {
    var best = null;
    library.files.forEach(function (f) {
      if (f.model !== model || hardwareFor(f.v) !== hw) return;
      if (!best || cmp(f.v, best.v) > 0) best = f;
    });
    return best;
  }
  function resolve(model, version) {
    var v = parseVersion(version);
    if (!v) return { status: 'unreadable' };
    var hw = hardwareFor(v), newest = newestFor(model, hw);
    if (!newest) return { status: 'nofile', hw: hw, v: v };
    return { status: cmp(newest.v, v) > 0 ? 'update' : 'ok', hw: hw, v: v, newest: newest };
  }
  function loadLibrary() {
    var url = LIBRARY.list + '?list-type=2' + (LIBRARY.prefix ? '&prefix=' + encodeURIComponent(LIBRARY.prefix) : '');
    var useSample = function (why) {
      library.files = []; library.loader = { mac: null, win: null, any: null, version: null }; library.source = 'error';
      log('Firmware library could not be read (' + why + ')', 'err');
      render();
    };
    library.source = 'loading';
    if (!window.fetch || !window.DOMParser) { useSample('browser too old'); return Promise.resolve(); }
    return fetch(url, { mode: 'cors' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.text();
    }).then(function (xml) {
      var doc = new DOMParser().parseFromString(xml, 'application/xml');
      var keys = Array.prototype.map.call(doc.getElementsByTagName('Key'), function (k) { return k.textContent; });
      var files = parseFiles(keys);
      if (!files.length) throw new Error('listing had no firmware zips');
      library.files = files; library.loader = parseLoader(keys); library.source = 'live';
      log('Firmware library: ' + files.length + ' releases listed from ' + LIBRARY.list + (library.loader.version ? ', Loader ' + library.loader.version : ''), 'ok');
      render();
    }).catch(function (e) { useSample(e && e.message ? e.message : 'listing unavailable'); });
  }

  /* ===================================================================== */
  var BUTTON_META = {
    prev:  { label: 'Prev',  icon: '<svg viewBox="0 0 24 24"><path d="M18 5v14L8 12z"/><rect x="5" y="5" width="2.5" height="14" rx="1"/></svg>' },
    open:  { label: 'Open',  icon: '<svg viewBox="0 0 24 24" class="stroke"><path d="M4 7h16M4 12h16M4 17h10"/></svg>' },
    next:  { label: 'Next',  icon: '<svg viewBox="0 0 24 24"><path d="M6 5v14l10-7z"/><rect x="16.5" y="5" width="2.5" height="14" rx="1"/></svg>' },
    play:  { label: 'Play',  icon: '<svg viewBox="0 0 24 24"><path d="M7 4v16l13-8z"/></svg>' },
    reset: { label: 'Reset', icon: '<svg viewBox="0 0 24 24" class="stroke"><path d="M4 12a8 8 0 1 0 2.3-5.7"/><path d="M4 4v5h5"/></svg>' },
    stop:  { label: 'Stop',  icon: '<svg viewBox="0 0 24 24"><rect x="5" y="5" width="14" height="14" rx="2"/></svg>' }
  };
  // Byte order inside the 25-byte assignment SysEx (both directions).
  var ORDER = ['play', 'reset', 'stop', 'prev', 'open', 'next'];
  var SHIFT_ORDER = ['play', 'stop', 'prev', 'open', 'next'];
  var DEFAULTS = { channel: 16, type: 0, shift: 0,
    buttons: { play: 36, reset: 37, stop: 38, prev: 39, open: 40, next: 41 },
    shiftButtons: { play: 42, stop: 43, prev: 44, open: 45, next: 46 },
    faders: [14, 15] };
  // Message types a button can send. Legacy firmware has one type for the whole
  // board (note or CC); the extended protocol below carries one per button.
  var TYPES = [{ v: 0, label: 'Note', short: 'Note' }, { v: 1, label: 'CC', short: 'CC' }, { v: 2, label: 'Program change', short: 'PC' }];
  function typeShort(t) { return (TYPES[t] || TYPES[0]).short; }

  /* Extended assignment protocol (proposed; page side implemented, firmware to follow)
     Request : F0 00 21 6E 7F 00 00 12 6E F7            (0x12 instead of the legacy 0x11)
     Reply / write, 37 bytes without LED colors, 55 with:
       [0]      F0
       [1..3]   00 21 6E                 Oaktone
       [4..6]   7F 00 00                 device id
       [7]      21                       extended assignments
       [8]      flags: bit0 per-button types (always set), bit1 LED colors follow the faders
       [9]      channel 1..16
       [10]     shift layer 0/1
       [11..22] play, reset, stop, prev, open, next   as [type, number] pairs
       [23..32] shift play, stop, prev, open, next    as [type, number] pairs
       [33..34] fader 1 CC, fader 2 CC
       [35..52] play, reset, stop, prev, open, next   as [r, g, b], 0..127 each  (only when bit1 is set)
       [next]   4E normal mode, 50 programming mode
       [last]   F7
     type: 0 note, 1 CC, 2 program change. Colors are 7-bit per channel; the board
     doubles them for its LEDs. A board that knows this protocol still answers the
     legacy 0x11 request with the 25-byte reply for old hosts. */
  var EXT_REQUEST = [0xF0, 0x00, 0x21, 0x6E, 0x7F, 0x00, 0x00, 0x12, 0x6E, 0xF7];
  var EXT_FLAG_TYPES = 1, EXT_FLAG_COLORS = 2;
  function isExtReply(d) { return d[7] === 0x21 && (d.length === 37 || d.length === 55); }
  // LED presets the swatch popover offers (7-bit RGB). The board's own defaults are green, red, cyan.
  var LED_PRESETS = [
    { name: 'Green', rgb: [0, 127, 0] }, { name: 'Red', rgb: [127, 0, 0] }, { name: 'Cyan', rgb: [0, 127, 127] },
    { name: 'Blue', rgb: [0, 0, 127] }, { name: 'Amber', rgb: [127, 64, 0] }, { name: 'Magenta', rgb: [127, 0, 127] },
    { name: 'White', rgb: [127, 127, 127] }, { name: 'Off', rgb: [0, 0, 0] }
  ];
  var LED_DEFAULTS = { play: [0, 127, 0], reset: [0, 127, 127], stop: [127, 0, 0], prev: [0, 127, 127], open: [0, 127, 127], next: [0, 127, 127] };
  function rgbHex(c) { return '#' + c.map(function (v) { return ('0' + Math.round(Math.min(127, Math.max(0, v)) * 255 / 127).toString(16)).slice(-2); }).join(''); }
  function hexRgb(h) { var m = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(h); return m ? [1, 2, 3].map(function (i) { return Math.round(parseInt(m[i], 16) * 127 / 255); }) : [0, 0, 0]; }
  function rgbCss(c, a) { var r = Math.round(c[0] * 255 / 127), g = Math.round(c[1] * 255 / 127), b = Math.round(c[2] * 255 / 127); return 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')'; }

  var $ = function (id) { return document.getElementById(id); };
  var NOTE_NAMES = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'];
  function noteName(n) { return NOTE_NAMES[n % 12] + (Math.floor(n / 12) - 2); } // Ableton: C3 = 60
  function hex(bytes) { var s = []; for (var i = 0; i < bytes.length; i++) { s.push(('0' + bytes[i].toString(16)).slice(-2).toUpperCase()); } return s.join(' '); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  var state = {
    browserOK: !!navigator.requestMIDIAccess,
    live: false,
    midiRefused: false,
    scanning: false,
    device: null,   // { model, version|null, port, mode: 'normal'|'programming', identified: bool }
    tool: 'firmware',
    pg: { model: 'OM', channel: DEFAULTS.channel, type: DEFAULTS.type, shift: DEFAULTS.shift,
          buttons: Object.assign({}, DEFAULTS.buttons), shiftButtons: Object.assign({}, DEFAULTS.shiftButtons),
          types: { play: 0, reset: 0, stop: 0, prev: 0, open: 0, next: 0 }, shiftTypes: { play: 0, stop: 0, prev: 0, open: 0, next: 0 },
          colors: null, // { play: [r,g,b], ... } when the board reports LED colors
          faders: DEFAULTS.faders.slice(), ext: false, dirty: false, loaded: false, pendingWrite: null, writeResult: '' },
    mon: { paused: false, count: 0, filters: { note: true, cc: true, pgm: true, pitch: true, sys: true, rt: false } },
    manual: { model: 'OF', version: '', error: '' }
  };

  /* ---------- Connection log ---------- */
  var logCount = 0;
  function log(msg, cls) {
    logCount++;
    var body = $('connBody'), now = new Date();
    var t = ('0' + now.getHours()).slice(-2) + ':' + ('0' + now.getMinutes()).slice(-2) + ':' + ('0' + now.getSeconds()).slice(-2);
    var row = document.createElement('div');
    row.innerHTML = '<span class="t">' + t + '</span><span class="' + (cls || '') + '">' + esc(msg) + '</span>';
    body.appendChild(row);
    while (body.children.length > 200) body.removeChild(body.firstChild);
    body.scrollTop = body.scrollHeight;
    $('connCount').textContent = logCount + (logCount === 1 ? ' entry' : ' entries');
    if (window.console && console.log) console.log('[' + PAGE_NAME + '] ' + msg);
  }

  function deviceTitle(d) {
    if (d.port && /oakboard/i.test(d.port)) return d.port.replace(/\s*\(.*?\)\s*$/, '');
    return MODELS[d.model].name;
  }

  // Chromium 152 ships a regression in its MIDI 1.0 to UMP/SysEx7 conversion that wraps
  // every outgoing SysEx in a stray F0 and F7, so devices never see a valid request.
  // Fixed in 153. Detect it so the page can say so instead of blaming the board.
  var BROKEN_CHROMIUM = { 152: true };
  function chromium() {
    var uad = navigator.userAgentData, i;
    if (uad && uad.brands) {
      for (i = 0; i < uad.brands.length; i++) { if (/^Chromium$/i.test(uad.brands[i].brand)) return { brand: 'Chromium', version: +uad.brands[i].version }; }
      for (i = 0; i < uad.brands.length; i++) { if (/Chrome|Edge|Brave|Opera/i.test(uad.brands[i].brand)) return { brand: uad.brands[i].brand, version: +uad.brands[i].version }; }
    }
    var m = /Chrome\/(\d+)/.exec(navigator.userAgent || '');
    return m ? { brand: 'Chrome', version: +m[1] } : null;
  }
  function brokenBrowser() { var c = chromium(); return !!(c && BROKEN_CHROMIUM[c.version]); }
  function browserName() { var c = chromium(); return c ? c.brand.replace(/^Chromium$/, 'Chrome') + ' ' + c.version : 'this browser'; }

  /* =====================================================================
     2. RENDER
     ===================================================================== */
  function render() { renderStrip(); renderFirmware(); renderProgrammer(); renderBrowser(); }

  function renderBrowser() {
    var note = $('browserNote');
    note.classList.remove('is-bad'); note.classList.remove('is-warn');
    if (!state.browserOK) {
      note.classList.add('is-bad');
      $('browserNoteText').textContent = "This browser can't talk to MIDI devices. Open this page in Chrome, Edge, Brave, or Opera to use " + PAGE_NAME + ".";
      $('railMode').textContent = 'No Web MIDI in this browser';
    } else if (!state.live && state.midiRefused) {
      note.classList.add('is-bad');
      $('browserNoteText').textContent = "This page needs permission to use MIDI, and the browser said no. Click the lock icon next to the address, allow MIDI devices, then reload.";
      $('railMode').textContent = 'MIDI permission refused';
    } else if (state.live && brokenBrowser()) {
      note.classList.add('is-warn');
      $('browserNoteText').innerHTML = esc(browserName()) + " has a bug that garbles the MIDI request this page sends, so Oakboards can't answer it. Chrome 153 fixes it: <a href=\"https://support.google.com/chrome/answer/95414\" target=\"_blank\" rel=\"noopener\">update Chrome</a> and relaunch, or <a href=\"https://www.google.com/chrome/beta/\" target=\"_blank\" rel=\"noopener\">install Chrome Beta</a>, which already has the fix.";
      $('railMode').textContent = 'Web MIDI live, ' + browserName() + ' SysEx bug';
    } else {
      $('browserNoteText').textContent = "Works in Chrome, Edge, Brave, and Opera on Mac and Windows. Safari and Firefox can't talk to MIDI devices yet.";
      $('railMode').textContent = state.live ? 'Web MIDI' : 'Web MIDI, waiting for permission';
    }
    $('scanBtn').disabled = !state.browserOK || state.scanning;
    $('scanBtn').className = 'tbtn' + (state.device ? '' : ' primary');
  }

  function renderStrip() {
    var d = state.device, dot = $('devDot');
    dot.className = 'st-dot';
    var v = $('kvVersion'), l = $('kvLatest'), m = $('kvMode');
    v.className = 'v muted'; l.className = 'v muted'; m.className = 'v muted';
    v.textContent = '--'; l.textContent = '--'; m.textContent = '--';
    if (!d) {
      if (state.scanning) {
        dot.classList.add('scanning');
        $('devName').textContent = 'Scanning';
        $('devSub').textContent = 'Asking every MIDI port to identify itself';
      } else {
        $('devName').textContent = state.browserOK ? 'No Oakboard' : 'Unsupported browser';
        $('devSub').textContent = state.browserOK ? 'Connect one over USB and press scan' : 'Web MIDI is required';
        if (!state.browserOK) dot.classList.add('bad');
      }
      return;
    }
    $('devName').textContent = deviceTitle(d);
    $('devSub').innerHTML = d.manual ? 'Typed by hand. Press scan to read the board directly' : 'Port <b>' + esc(d.port) + '</b>';
    if (!d.identified) {
      if (state.scanning) { dot.classList.add('scanning'); v.textContent = 'Reading'; }
      else { dot.classList.add('standby'); v.textContent = 'No reply'; v.className = 'v standby'; }
      m.textContent = 'Normal'; m.className = 'v';
      return;
    }
    var r = resolve(d.model, d.version);
    v.textContent = d.version; v.className = 'v';
    if (r.status === 'update') { dot.classList.add('standby'); l.textContent = vstr(r.newest.v); l.className = 'v standby'; }
    else if (r.status === 'ok') { dot.classList.add('ok'); l.textContent = vstr(r.newest.v); l.className = 'v accent'; }
    else if (r.status === 'nofile') { dot.classList.add('ok'); l.textContent = d.version; l.className = 'v accent'; }
    else { dot.classList.add('bad'); l.textContent = '?'; }
    if (d.manual) { m.textContent = '--'; m.className = 'v muted'; }
    else if (d.mode === 'programming') { m.textContent = 'Programming'; m.className = 'v standby'; }
    else { m.textContent = 'Not reported'; m.className = 'v muted'; }
  }

  function tbtn(label, cls, href) {
    var inner = '<span>' + label + '</span>';
    if (href) return '<a class="tbtn sm ' + (cls || '') + '" href="' + esc(href) + '" target="_blank" rel="noopener" style="text-decoration:none">' + inner + '</a>';
    return '<button type="button" class="tbtn sm ' + (cls || '') + '">' + inner + '</button>';
  }

  function stepsFor(r, model) {
    var v = vstr(r.newest.v), short = MODELS[model].short;
    if (HW[r.hw].install === 'loader') {
      return '<ol class="steps">' +
        '<li><div class="st"><b>Download ' + short + ' ' + v + '</b><span>' + (r.newest.ext === 'zip' ? 'A zip with the firmware file and a README.' : 'The firmware file itself, under a megabyte. Save it somewhere you can find in a minute.') + ' This is the only file for this board; the Loader shows its name before you install.</span>' +
        '<div class="actions">' + tbtn('Download ' + v, 'glow', r.newest.url) + '</div></div></li>' +
        '<li><div class="st"><b>Get the Oaktone Firmware Loader, if you don\'t have it yet</b><span>A small desktop app for Mac and Windows. One download covers every Oakboard; keep it around for next time.</span>' +
        '<div class="actions">' + loaderButtons('') + '</div></div></li>' +
        '<li><div class="st"><b>Put the ' + short + ' in bootloader mode</b><span>Unplug it. Hold <kbd>STOP</kbd> while you plug it back in. The buttons stay dark, and that is what you want.</span></div></li>' +
        '<li><div class="st"><b>Install</b><span>In the Loader press <kbd>SCAN MIDI DEVICES</kbd>, drop the firmware file on the ring, then <kbd>INSTALL FIRMWARE</kbd>. When it says flashing complete, reconnect the ' + short + ' and press scan up here to confirm.</span></div></li>' +
        '</ol>';
    }
    return '<ol class="steps">' +
      '<li><div class="st"><b>Download ' + short + ' ' + v + '</b><span>' + (r.newest.ext === 'zip' ? 'One zip: the firmware file and a README written for this board.' : 'The firmware file for this board.') + '</span>' +
      '<div class="actions">' + tbtn('Download ' + v, 'glow', r.newest.url) + '</div></div></li>' +
      '<li><div class="st"><b>Unzip it and follow the README</b><span>It walks through the Teensy loader step by step. Ten minutes, no soldering.</span></div></li>' +
      '<li><div class="st"><b>Reconnect and scan</b><span>Come back here and press scan to confirm the ' + short + ' reports ' + v + '.</span></div></li>' +
      '</ol>';
  }

  // Fallback for browsers that can't ask the board: the person types what the
  // Firmware Loader (or the old page) showed, and the same resolver does the rest.
  function manualForm(title, preferModel) {
    var m = state.manual, sel = preferModel || m.model;
    return '<form class="manual" id="manualForm" autocomplete="off">' +
      '<div class="manual-title">' + esc(title) + '</div>' +
      '<div class="manual-row">' +
      '<select class="csel" name="model" aria-label="Oakboard model">' +
      ['OF', 'OS', 'OM'].map(function (k) { return '<option value="' + k + '"' + (k === sel ? ' selected' : '') + '>' + MODELS[k].name + '</option>'; }).join('') +
      '</select>' +
      '<input class="csel" name="version" inputmode="decimal" placeholder="Version, like 1.9.4" value="' + esc(m.version || '') + '" aria-label="Firmware version">' +
      '<button type="submit" class="tbtn sm"><span>Check</span></button>' +
      '</div>' +
      (m.error ? '<div class="manual-err">' + esc(m.error) + '</div>' : '') +
      '</form>';
  }

  function libraryNote() {
    if (library.source === 'live') return '';
    if (library.source === 'loading') return '<div class="lib-note">Loading the firmware list.</div>';
    return '<div class="lib-note lib-err">The firmware list couldn\'t be loaded, so this page can\'t tell which release is newest right now. ' +
      '<button type="button" class="lib-retry" id="libRetry">Try again</button></div>';
  }
  function renderLoaderBox() {
    var lv = library.loader.version;
    $('loaderBox').innerHTML = '<div class="lb-title">Oaktone Firmware Loader' + (lv ? ' <span>' + esc(lv) + '</span>' : '') + '</div>' +
      '<div class="lb-text">Installs firmware on USB-C Oakboards. One app for every board.</div>' +
      '<div class="lb-actions' + (loaderIsSingle() ? ' one' : '') + '">' + (loaderIsSingle() ? tbtn('Download', '', library.loader.any.url) : tbtn('Mac', '', loaderLink('mac')) + tbtn('Windows', '', loaderLink('win'))) + '</div>';
  }
  function renderFirmware() {
    var ring = $('ring'), meta = $('ringMeta'), todo = $('todo'), d = state.device;
    ring.className = 'ring';
    renderLoaderBox();
    var setRing = function (model, ver, small, stateText) {
      $('ringModel').textContent = model;
      $('ringVer').className = 'ver' + (small ? ' small' : ''); $('ringVer').textContent = ver;
      $('ringState').textContent = stateText;
    };
    if (!d && state.scanning) {
      ring.classList.add('scanning'); setRing('Oakboard', 'Listening', true, 'Identity request sent');
      meta.innerHTML = '';
      todo.innerHTML = '<h2>Scanning every MIDI port.</h2><p>Oakboards answer a standard identity request with their model and firmware version. This takes about a second.</p>';
      return;
    }
    if (!d) {
      ring.classList.add(state.browserOK ? 'none' : 'bad');
      setRing('Oakboard', state.browserOK ? 'Nothing connected' : 'Web MIDI needed', true, state.browserOK ? 'Press scan' : 'Use Chrome or Edge');
      meta.innerHTML = '<div><span>Reads</span><span>Model and firmware only</span></div><div><span>Writes</span><span>Nothing until you ask</span></div>';
      if (state.browserOK) {
        todo.innerHTML = libraryNote() + '<h2>Connect an Oakboard over USB, then press scan.</h2>' +
          '<p>Any Oakboard works, in normal or programming mode, through a hub or an iConnectivity host port. If several are plugged in, the page picks the first one that answers; unplug the others to check a specific unit.</p>' +
          '<p>Once it answers, this spot shows the firmware it is running, whether there is a newer one for that exact board, and the steps to install it.</p>' +
          manualForm('No board at hand? Type the model and version instead');
      } else {
        todo.innerHTML = '<h2>This browser can\'t talk to MIDI devices, but you can still find the right firmware.</h2>' +
          '<p>Open this page in Chrome, Edge, Brave, or Opera and it reads the board for you. Or run the Oaktone Firmware Loader, press Scan, and type what it reports here.</p>' +
          manualForm('Type the model and version');
      }
      return;
    }
    var model = MODELS[d.model], title = deviceTitle(d);
    if (!d.identified) {
      if (state.scanning) {
        ring.classList.add('scanning'); setRing(title, 'Reading', true, 'Identity request sent');
        meta.innerHTML = '<div><span>Port</span><span>' + esc(d.port) + '</span></div>';
        todo.innerHTML = '<h2>' + esc(title) + ' is connected. Reading its firmware.</h2><p>The board answers a standard identity request with its model and version. About a second.</p>';
      } else {
        ring.classList.add('standby'); setRing(title, 'No reply', true, 'Try again');
        meta.innerHTML = '<div><span>Port</span><span>' + esc(d.port) + '</span></div><div><span>Answered</span><span>No</span></div>';
        if (state.live && brokenBrowser()) {
          todo.innerHTML = '<h2>' + esc(title) + ' is connected, but ' + esc(browserName()) + ' is garbling the request.</h2>' +
            '<p>This Chrome version has a known bug that wraps every outgoing MIDI message of this kind in stray bytes, so the ' + esc(model.short) + ' never sees a valid request. Nothing is wrong with the board. Chrome 153 fixes it.</p>' +
            '<ol class="steps">' +
            '<li><div class="st"><b>Update Chrome, then come back</b><span>Chrome updates itself; it only needs a relaunch. If About Google Chrome still says 152, Chrome Beta already has the fix.</span>' +
            '<div class="actions">' + tbtn('How to update Chrome', 'glow', 'https://support.google.com/chrome/answer/95414') + tbtn('Get Chrome Beta', '', 'https://www.google.com/chrome/beta/') + '</div></div></li>' +
            '<li><div class="st"><b>Or read the version with the Firmware Loader</b><span>The Loader talks to the board directly, so the browser bug doesn\'t touch it. Open it, press <kbd>SCAN MIDI DEVICES</kbd>, and type what it reports below.</span></div></li>' +
            '</ol>' +
            manualForm('Type what the Loader reports', d.model);
        } else {
          todo.innerHTML = '<h2>' + esc(title) + ' is connected but didn\'t answer the identity request.</h2>' +
            '<p>Usually a board that is mid-boot or a hub that swallowed the reply. Unplug the ' + esc(model.short) + ', plug it straight into the computer, wait for the button sweep to finish, then press scan again.</p>' +
            '<p>If it still stays quiet, open the connection log at the bottom of this panel and send us what it says.</p>' +
            manualForm('Or type the model and version', d.model);
        }
      }
      return;
    }
    if (library.source !== 'live') {
      ring.classList.add('none'); setRing(title, d.version, false, library.source === 'loading' ? 'Checking' : 'List unavailable');
      meta.innerHTML = '<div><span>Port</span><span>' + esc(d.manual ? 'Typed by hand' : d.port) + '</span></div>';
      todo.innerHTML = libraryNote() + '<h2>' + esc(model.short) + ' reports firmware ' + esc(d.version) + '.</h2>' +
        '<p>' + (library.source === 'loading' ? 'Comparing it with the newest release in a moment.' : 'Reload the page or press Try again; the board is fine, only the release list is unreachable.') + '</p>';
      return;
    }
    var r = resolve(d.model, d.version);
    var hwRow = (d.manual ? '<div><span>Source</span><span>Typed by hand</span></div>' : '') + (r.hw ? '<div><span>Hardware</span><span>' + HW[r.hw].label + '</span></div>' : '');
    var installRow = r.hw ? '<div><span>Installs with</span><span>' + (HW[r.hw].install === 'loader' ? 'Oaktone Firmware Loader' : 'Zip and README') + '</span></div>' : '';
    if (r.status === 'ok' || r.status === 'nofile') {
      ring.classList.add('ok'); setRing(title, d.version, false, 'Up to date');
      meta.innerHTML = hwRow + '<div><span>Newest</span><span>' + (r.newest ? vstr(r.newest.v) : d.version) + '</span></div>' + installRow;
      todo.innerHTML = libraryNote() + '<h2>' + esc(model.short) + ' is on <span class="hl">' + esc(d.version) + '</span>, the newest firmware for this board.</h2>' +
        '<p>Nothing to install. When a release goes out for this board, scanning here will show the update and the steps.</p>' +
        '<div class="notes"><b>Other tools</b>Programmer changes what the buttons send. MIDI Monitor shows what the board is sending right now.</div>';
    } else if (r.status === 'update') {
      var nv = vstr(r.newest.v);
      ring.classList.add('standby'); setRing(title, d.version, false, 'Update to ' + nv);
      meta.innerHTML = hwRow + '<div><span>Newest</span><span>' + nv + '</span></div>' + installRow;
      todo.innerHTML = libraryNote() + '<h2>' + esc(model.short) + ' <span class="hl standby">' + nv + '</span> is ready. This board has ' + esc(d.version) + '.</h2>' +
        '<p>' + (HW[r.hw].install === 'loader' ? 'About five minutes with the Firmware Loader.' : 'About ten minutes with the Teensy loader in the zip.') + ' Your button assignments are kept.</p>' +
        stepsFor(r, d.model);
    } else {
      ring.classList.add('bad'); setRing(title, d.version, true, 'Unreadable version');
      meta.innerHTML = '<div><span>Reported</span><span>' + esc(d.version) + '</span></div>';
      todo.innerHTML = '<h2>This ' + esc(model.short) + ' reported a version the page can\'t read.</h2>' +
        '<p>Send us what it says (' + esc(d.version) + ') and the serial on the bottom of the unit and we\'ll sort it out.</p>' +
        '<div class="actions" style="display:flex;gap:10px;flex-wrap:wrap">' + tbtn('Email support', 'standby', 'mailto:' + SUPPORT_EMAIL + '?subject=' + encodeURIComponent(model.name + ' firmware ' + d.version)) + tbtn('Help Center', '', HELP_URL) + '</div>';
    }
  }

  /* ---------- Programmer ---------- */
  function renderProgrammer() {
    var d = (state.device && !state.device.manual) ? state.device : null, pg = state.pg, banner = $('pgBanner');
    var detected = d ? d.model : null;
    var modelCode = detected || pg.model;
    var model = MODELS[modelCode];
    // The board answers the assignment request in every mode, so having the
    // assignments says nothing about programming mode. Writes are verified by
    // reading back instead; a firmware that reports its mode lights the banner green.
    var editable = !!(d && pg.loaded);
    $('pgModelField').hidden = !!detected;
    $('pgModel').value = modelCode;

    var info = '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M12 8v5M12 16h.01"/></svg>';
    var tick = '<svg viewBox="0 0 24 24"><path d="M5 12l4 4L19 6"/></svg>';
    var enter = 'Unplug it, hold <kbd>PLAY</kbd> and <kbd>PREV</kbd> while plugging it back in, and keep holding until every button flashes twice and stays lit.';
    var name = d ? deviceTitle(d) : model.short;
    banner.className = 'banner';
    if (!d) {
      banner.innerHTML = info + '<div class="bt"><b>No Oakboard connected. Showing the ' + esc(model.short) + ' layout as a preview.</b><span>To program a board: ' + enter + ' Then press scan.</span></div>';
    } else if (!pg.loaded) {
      banner.classList.add('standby');
      banner.innerHTML = info + '<div class="bt"><b>' + esc(name) + ' didn\'t answer the assignment request yet.</b><span>Press <kbd>READ FROM OAKBOARD</kbd>. If it stays quiet, unplug it, plug it straight into the computer, and scan again.</span></div>';
    } else if (pg.writeResult === 'pending') {
      banner.classList.add('standby');
      banner.innerHTML = info + '<div class="bt"><b>Writing, then reading back to confirm.</b><span>About a second.</span></div>';
    } else if (pg.writeResult === 'saved') {
      banner.classList.add('ok');
      banner.innerHTML = tick + '<div class="bt"><b>Saved. ' + esc(name) + ' read back the new assignments.</b><span>They are in the board now and survive a power cycle. On a Slide Duo, program USB-A and USB-B separately.</span></div>';
    } else if (pg.writeResult === 'ignored') {
      banner.classList.add('bad');
      banner.innerHTML = info + '<div class="bt"><b>' + esc(name) + ' ignored the write, so it isn\'t in programming mode.</b><span>Your edits are still here. ' + enter + ' Then press <kbd>READ</kbd> and <kbd>WRITE</kbd> again.</span></div>';
    } else if (pg.writeResult === 'noreply') {
      banner.classList.add('standby');
      banner.innerHTML = info + '<div class="bt"><b>Wrote, but ' + esc(name) + ' didn\'t answer the read-back.</b><span>Press <kbd>READ FROM OAKBOARD</kbd> to see what it has now.</span></div>';
    } else if (d.mode === 'programming') {
      banner.classList.add('ok');
      banner.innerHTML = tick + '<div class="bt"><b>Programming mode. These are the assignments on ' + esc(name) + ' right now.</b><span>Change anything, then press <kbd>WRITE TO OAKBOARD</kbd>. On a Slide Duo, program USB-A and USB-B separately.</span></div>';
    } else {
      banner.innerHTML = info + '<div class="bt"><b>These are the assignments on ' + esc(name) + ' right now.</b><span>Saving needs programming mode, every button lit. If they aren\'t: ' + enter + ' Then edit and press <kbd>WRITE TO OAKBOARD</kbd>; the page reads the board back to confirm it took.</span></div>';
    }

    var ch = $('pgChannel');
    if (!ch.options.length) { for (var i = 1; i <= 16; i++) { var o = document.createElement('option'); o.value = i; o.textContent = 'Channel ' + i; ch.appendChild(o); } }
    ch.value = pg.channel;
    var ext = !!pg.ext;
    $('pgTypeLabel').textContent = ext ? 'Set every button to' : 'Buttons send';
    $('pgTypePC').hidden = !ext;
    seg($('pgType'), ext ? -1 : pg.type); seg($('pgShift'), pg.shift);
    $('pgShiftField').hidden = !model.shift;

    var b = $('board');
    b.className = 'board' + (editable ? '' : ' readonly');
    var typeOf = function (key, shiftRow) { return ext ? (shiftRow ? pg.shiftTypes[key] : pg.types[key]) : pg.type; };
    var rowHTML = function (key, shiftRow, enabled) {
      var t = typeOf(key, shiftRow), n = shiftRow ? pg.shiftButtons[key] : pg.buttons[key];
      var lbl = shiftRow ? 'Shift' : typeShort(t);
      var html = '<div class="row' + (shiftRow ? ' shift' + (pg.shift ? '' : ' off') : '') + (ext ? ' ext' : '') + '">';
      if (ext) html += '<span class="lbl">' + (shiftRow ? 'Shift' : 'Sends') + '</span>' + typeSelect((shiftRow ? 't-s-' : 't-b-') + key, t, enabled);
      else html += '<span class="lbl">' + lbl + '</span>';
      html += numSelect((shiftRow ? 's-' : 'b-') + key, n, enabled, t === 0) + '</div>';
      return html;
    };
    var html = '<div class="board-title"><b>' + esc(model.name) + '</b><span>' + (ext ? 'Per-button types' : (pg.type ? 'CC numbers' : 'Note numbers')) + ', channel ' + pg.channel + '</span></div>';
    html += '<div class="btn-grid' + (model.cols === 2 ? ' cols-2' : '') + '">';
    model.buttons.forEach(function (key) {
      var m = BUTTON_META[key], isShiftKey = model.shift && pg.shift === 1 && key === 'reset';
      var hasShift = model.shift && key !== 'reset';
      var led = pg.colors && pg.colors[key];
      var style = led ? ' style="--led:' + rgbCss(led, 1) + ';--led-line:' + rgbCss(led, .55) + ';--led-soft:' + rgbCss(led, .18) + '"' : '';
      html += '<div class="btile' + (isShiftKey ? ' dim' : '') + (led ? ' lit' : '') + '" data-btn="' + key + '"' + style + '><div class="cap">' + m.icon + '<b>' + m.label + '</b>' +
        (led ? '<button type="button" class="swatch" data-swatch="' + key + '" title="LED color"' + (editable ? '' : ' disabled') + '><span></span></button>' : '') + '</div>';
      if (isShiftKey) html += '<div class="row keynote">Shift key. Hold it and the other buttons send their second message.</div>';
      else { html += rowHTML(key, false, editable); if (hasShift) html += rowHTML(key, true, editable && !!pg.shift); }
      html += '</div>';
    });
    html += '</div>';
    if (model.faders) {
      html += '<div class="faders">';
      for (var f = 0; f < model.faders; f++) {
        html += '<div class="ftile" data-fader="' + f + '"><b>Fader ' + (f + 1) + '</b><div class="slot"><i></i></div><small>CC</small>' + numSelect('f-' + f, pg.faders[f], editable) + '</div>';
      }
      html += '</div>';
    }
    html += '<div class="board-note">' + (model.shift ? 'Shift adds a second message to Prev, Open, Next, Play, and Stop. ' : '') + (model.faders ? 'Faders always send CC. ' : '') +
      (ext ? 'Each button picks its own message: note, CC, or program change. One channel for the whole board.' : 'One channel and one message type for the whole board' + (d ? ' on this firmware' : '') + '.') +
      (pg.colors ? ' Click a swatch to change that button\'s LED color.' : '') + '</div>';
    b.innerHTML = html;

    $('pgRead').disabled = !d;
    $('pgWrite').disabled = !editable;
    $('pgWrite').className = 'tbtn block' + (editable && pg.dirty && pg.writeResult !== 'pending' ? ' glow' : '');
    $('pgWrite').disabled = !editable || pg.writeResult === 'pending';
    $('pgRead').className = 'tbtn block' + (d && !pg.loaded ? ' primary' : '');
  }
  function typeSelect(id, val, enabled) {
    var s = '<select class="csel tsel" id="' + id + '"' + (enabled ? '' : ' disabled') + '>';
    TYPES.forEach(function (t) { s += '<option value="' + t.v + '"' + (t.v === val ? ' selected' : '') + '>' + t.short + '</option>'; });
    return s + '</select>';
  }
  function numSelect(id, val, enabled, withNames) {
    var s = '<select class="csel" id="' + id + '"' + (enabled ? '' : ' disabled') + '>';
    for (var i = 0; i < 128; i++) s += '<option value="' + i + '"' + (i === val ? ' selected' : '') + '>' + i + (withNames ? ' ' + noteName(i) : '') + '</option>';
    return s + '</select>';
  }
  function seg(el, v) { Array.prototype.forEach.call(el.querySelectorAll('button'), function (b) { b.setAttribute('aria-pressed', String(+b.dataset.v === +v)); }); }

  /* ---------- MIDI monitor ---------- */
  function classify(d) {
    var s = d[0];
    if (s === 0xF0) return { kind: 'sys', type: 'SysEx', cls: 'sys', detail: d.length + ' bytes' + (d[1] === 0x7E ? ' <span>universal</span>' : (d[1] === 0 && d[2] === 0x21 ? ' <span>Oaktone</span>' : '')) };
    if (s >= 0xF8) { var names = { 0xF8: 'Clock', 0xFA: 'Start', 0xFB: 'Continue', 0xFC: 'Stop', 0xFE: 'Active sense' }; return { kind: 'rt', type: names[s] || 'Realtime', cls: 'rt', detail: '' }; }
    if (s >= 0xF1) return { kind: 'rt', type: s === 0xF1 ? 'MTC' : 'System', cls: 'rt', detail: d.length > 1 ? String(d[1]) : '' };
    var ch = (s & 0x0F) + 1, hi = s & 0xF0, d1 = d[1] || 0, d2 = d[2] || 0;
    switch (hi) {
      case 0x90: return d2 === 0 ? { kind: 'note', type: 'Note off', cls: 'off', detail: d1 + ' <span>' + noteName(d1) + ' ch ' + ch + '</span>' }
                                 : { kind: 'note', type: 'Note on', cls: '', detail: d1 + ' <span>' + noteName(d1) + ' vel ' + d2 + ' ch ' + ch + '</span>' };
      case 0x80: return { kind: 'note', type: 'Note off', cls: 'off', detail: d1 + ' <span>' + noteName(d1) + ' ch ' + ch + '</span>' };
      case 0xB0: return { kind: 'cc', type: 'CC', cls: '', detail: 'CC ' + d1 + ' <span>val ' + d2 + ' ch ' + ch + '</span>' };
      case 0xC0: return { kind: 'pgm', type: 'Program', cls: '', detail: d1 + ' <span>ch ' + ch + '</span>' };
      case 0xE0: return { kind: 'pitch', type: 'Pitch', cls: '', detail: ((d2 << 7 | d1) - 8192) + ' <span>ch ' + ch + '</span>' };
      case 0xA0: case 0xD0: return { kind: 'note', type: 'Aftertouch', cls: '', detail: d1 + ' <span>' + (hi === 0xA0 ? d2 + ' ' : '') + 'ch ' + ch + '</span>' };
    }
    return { kind: 'rt', type: 'Other', cls: 'rt', detail: '' };
  }
  // Light the matching tile when the physical button or fader is used.
  function flashForMessage(d) {
    var pg = state.pg, s = d[0], hi = s & 0xF0, ch = (s & 0x0F) + 1;
    if (!pg.loaded || s >= 0xF0 || ch !== pg.channel) return;
    var type = hi === 0x90 && d[2] > 0 ? 0 : hi === 0xB0 ? 1 : hi === 0xC0 ? 2 : -1;
    if (type < 0) return;
    var n = d[1];
    if (type === 1 && pg.faders.indexOf(n) !== -1) { var ft = document.querySelector('.ftile[data-fader="' + pg.faders.indexOf(n) + '"]'); if (ft) { ft.classList.add('pressed'); clearTimeout(ft._t); ft._t = setTimeout(function () { ft.classList.remove('pressed'); }, 260); } return; }
    if (type === 1 && d[2] === 0) return;
    ORDER.forEach(function (k) { if (pg.buttons[k] === n && (pg.ext ? pg.types[k] : pg.type) === type) pressTile(k); });
    SHIFT_ORDER.forEach(function (k) { if (pg.shift && pg.shiftButtons[k] === n && (pg.ext ? pg.shiftTypes[k] : pg.type) === type) pressTile(k); });
  }
  function monitorPush(d, port) {
    flashForMessage(d);
    var c = classify(d);
    state.mon.count++;
    if (state.mon.paused || !state.mon.filters[c.kind]) { updateCount(); return; }
    var lt = $('lastType'), ld = $('lastDetail');
    lt.className = 'type ' + (c.cls === 'sys' ? 'sys' : c.cls === 'rt' ? 'rt' : '');
    lt.textContent = c.type;
    ld.innerHTML = c.detail.replace('<span>', '<small>').replace('</span>', '</small>') || '<small>' + esc(port) + '</small>';
    var body = $('logBody'), empty = body.querySelector('.log-empty');
    if (empty) empty.remove();
    var now = new Date(), t = ('0' + now.getMinutes()).slice(-2) + ':' + ('0' + now.getSeconds()).slice(-2) + '.' + ('00' + now.getMilliseconds()).slice(-3);
    var row = document.createElement('div');
    row.className = 'log-row';
    row.innerHTML = '<span class="t">' + t + '</span><span class="p" title="' + esc(port) + '">' + esc(port) + '</span><span class="ty ' + c.cls + '">' + c.type + '</span><span class="d">' + c.detail + '</span><span class="h">' + hex(d.length > 12 ? Array.prototype.slice.call(d, 0, 12) : d) + (d.length > 12 ? ' …' : '') + '</span>';
    body.insertBefore(row, body.firstChild);
    while (body.children.length > 300) body.removeChild(body.lastChild);
    updateCount();
  }
  function updateCount() { $('monCount').textContent = state.mon.count + (state.mon.count === 1 ? ' message' : ' messages') + (state.mon.paused ? ', paused' : ''); }

  /* =====================================================================
     3. REAL WEB MIDI (takes over automatically when the browser grants it)
     ===================================================================== */
  var midi = null, scanTimer = null, progTimer = null, stateTimer = null, portStates = {};
  var INQUIRY = [0xF0, 0x7E, 0x7F, 0x06, 0x01, 0xF7];

  function modelFromName(name) {
    if (/floor\s*vista/i.test(name)) return 'OF';
    if (/slide\s*duo/i.test(name)) return 'OS';
    if (/mini/i.test(name) && /oak/i.test(name)) return 'OM';
    return null;
  }
  function initMIDI() {
    if (!navigator.requestMIDIAccess) { log('Web MIDI is not available in this browser', 'err'); return Promise.resolve(false); }
    return navigator.requestMIDIAccess({ sysex: true }).then(function (access) {
      midi = access; state.live = true;
      var c = chromium();
      log('Browser: ' + (c ? c.brand + ' ' + c.version : navigator.userAgent) + (brokenBrowser() ? ' (known SysEx framing bug, fixed in 153)' : ''), brokenBrowser() ? 'err' : '');
      log('Web MIDI access granted. sysexEnabled = ' + access.sysexEnabled + ', ' + access.inputs.size + ' input(s), ' + access.outputs.size + ' output(s)', access.sysexEnabled ? 'ok' : 'err');
      if (!access.sysexEnabled) log('Without SysEx the page cannot ask the board who it is. Reload and allow "control and reprogram MIDI devices".', 'err');
      midi.inputs.forEach(function (p) { hookInput(p); portStates[p.id] = p.state; log('Input: ' + p.name + ' [' + p.manufacturer + '] ' + p.state + '/' + p.connection); });
      midi.outputs.forEach(function (p) { portStates[p.id] = p.state; log('Output: ' + p.name + ' [' + p.manufacturer + '] ' + p.state + '/' + p.connection); });
      ttPorts();
      midi.onstatechange = function (e) {
        var p = e.port; if (!p) return;
        if (portStates[p.id] === p.state) return; // connection open/close chatter, not a plug event
        portStates[p.id] = p.state;
        log((p.type === 'input' ? 'Input ' : 'Output ') + p.name + ' ' + p.state, p.state === 'connected' ? 'ok' : 'warn');
        if (p.type === 'input' && p.state === 'connected') hookInput(p);
        ttPorts();
        if (state.device && p.state === 'disconnected' && p.type === 'input' && p.name === state.device.port) { state.device = null; state.pg.loaded = false; render(); }
        clearTimeout(stateTimer); stateTimer = setTimeout(scan, 700);
      };
      return true;
    }, function (err) { state.midiRefused = true; log('Web MIDI access refused: ' + (err && err.message ? err.message : err), 'err'); return false; });
  }
  function hookInput(input) { input.onmidimessage = onMessage; }
  function onMessage(e) {
    var d = e.data, port = (e.target && e.target.name) || 'MIDI in';
    if (TT.inPort && e.target && e.target.id === TT.inPort && (d[0] & 0xF0) === 0x90 && d[2] > 0) {
      var tt = e.timeStamp || ttNow();
      if (TT.lastTap == null || tt - TT.lastTap > 60) ttTap(tt, 'midi');   // 60 ms guard against a looped-back tap note
    }
    if (d[0] === 0xF0) {
      if (d[1] === 0x7E && d[3] === 0x06 && d[4] === 0x02) { log('Identity reply from ' + port + ': ' + hex(d)); parseIdentity(d, port); }
      else if ((d.length === 25 || isExtReply(d)) && d[1] === 0x00 && d[2] === 0x21) { log('Assignments received from ' + port + ': ' + hex(d)); parseAssignments(d); }
      else log('SysEx from ' + port + ': ' + hex(d.length > 24 ? Array.prototype.slice.call(d, 0, 24) : d) + (d.length > 24 ? ' …' : ''));
    }
    monitorPush(d, port);
  }
  // Reply layout (FirmwareLoader/oakboard_inquiry.dart):
  // F0 7E ch 06 02 | 00 21 6E | 01 01 | model(2) | version(4) | F7   (17 bytes)
  // A 1-byte manufacturer id shifts everything after byte 5 left by two.
  function parseIdentity(m, port) {
    var off = m[5] === 0x00 ? 0 : -2;
    if (m.length < 17 + off) { log('Identity reply too short to parse', 'warn'); return; }
    if (off === 0 && !(m[6] === 0x21 && (m[7] === 0x6E || m[7] === 0x6A))) log('Manufacturer id is not Oaktone (' + hex([m[5], m[6], m[7]]) + '), parsing anyway', 'warn');
    var code = String.fromCharCode(m[10 + off], m[11 + off]);
    if (!MODELS[code]) { log('Not an Oakboard model code: "' + code + '"', 'warn'); return; }
    var v = m[12 + off] + '.' + m[13 + off] + '.' + m[14 + off];
    var extra = m[15 + off];
    if (extra === 0x4C) v += 'L'; else if (extra && extra !== 0xF7) v += '.' + extra;
    state.scanning = false; clearTimeout(scanTimer);
    state.device = { model: code, version: v, port: port, mode: 'unknown', identified: true };
    state.pg.loaded = false; state.pg.ext = false; state.pg.dirty = false; state.pg.pendingWrite = null; state.pg.writeResult = '';
    log('Identified ' + MODELS[code].name + ' firmware ' + v + ' on ' + port, 'ok');
    render();
    requestAssignments(true);
  }
  function allOutputs() {
    var outs = [];
    if (midi) midi.outputs.forEach(function (o) { if (o.state === 'connected') outs.push(o); });
    return outs;
  }
  function oakOutputs() {
    var outs = allOutputs().filter(function (o) { return /oakboard/i.test(o.name); });
    return outs.length ? outs : allOutputs();
  }
  // Open each port explicitly, then send, and say exactly what happened.
  function sendTo(outs, bytes, what) {
    if (!outs.length) { log(what + ': no connected MIDI outputs to send to', 'warn'); return Promise.resolve(0); }
    return Promise.all(outs.map(function (o) {
      var opened;
      try { opened = typeof o.open === 'function' ? o.open() : Promise.resolve(o); } catch (e) { opened = Promise.reject(e); }
      return Promise.resolve(opened).then(function () {
        o.send(bytes);
        return o.name + ' (' + o.connection + ')';
      }).catch(function (err) {
        log('Could not send ' + what + ' to ' + o.name + ': ' + (err && err.message ? err.message : err), 'err');
        return null;
      });
    })).then(function (names) {
      var ok = names.filter(Boolean);
      log(what + ' ' + hex(bytes) + ' sent to ' + ok.length + ' output' + (ok.length === 1 ? '' : 's') + (ok.length ? ': ' + ok.join(', ') : ''), ok.length ? '' : 'warn');
      return ok.length;
    });
  }
  var scanRound = 0;
  function scan() {
    if (!state.browserOK) return;
    if (!state.live) { initMIDI().then(function (ok) { render(); if (ok) scan(); }); return; }
    clearTimeout(scanTimer);
    var round = ++scanRound;
    state.scanning = true; state.device = null; state.pg.loaded = false;
    // Name-based first look, so the page can say "Oakboard Mini 2 connected" before the reply lands.
    var named = null;
    midi.inputs.forEach(function (p) { if (!named && p.state === 'connected' && modelFromName(p.name)) named = p; });
    if (named) {
      state.device = { model: modelFromName(named.name), version: null, port: named.name, mode: 'normal', identified: false };
      log('Oakboard port found by name: ' + named.name);
    } else log('No port named like an Oakboard; asking every output anyway');
    render();
    // Broadcast the universal identity request to every output (as the Firmware Loader does),
    // then once more after a moment for boards that were still booting.
    var ask = function (label) {
      if (round !== scanRound || !state.scanning) return;
      sendTo(allOutputs(), INQUIRY, label);
    };
    setTimeout(function () { ask('Identity request'); }, 150);
    setTimeout(function () { if (state.scanning && !(state.device && state.device.identified)) ask('Identity request, second try'); }, 1300);
    scanTimer = setTimeout(function () {
      if (!state.scanning || round !== scanRound) return;
      state.scanning = false;
      log(state.device ? 'No identity reply from ' + state.device.port + ' within 2.6 s' : 'No identity reply within 2.6 s', 'warn');
      render();
    }, 2600);
  }
  function requestAssignments(silent) {
    if (!state.live) return;
    // Extended request first; boards that don't know it stay silent and answer the legacy one.
    sendTo(oakOutputs(), EXT_REQUEST, 'Extended assignment request');
    setTimeout(function () { sendTo(oakOutputs(), [0xF0, 0x00, 0x21, 0x6E, 0x7F, 0x00, 0x00, 0x11, 0x6E, 0xF7], 'Assignment request'); }, 120);
    clearTimeout(progTimer);
    progTimer = setTimeout(function () {
      if (state.device && !state.pg.loaded) { log('No assignment reply within ' + (silent ? 0.9 : 1.2) + ' s', 'warn'); render(); }
    }, silent ? 900 : 1200);
  }
  // 25-byte reply: F0 00 21 6E 7F 00 00 | ch type shift | 6 buttons | 5 shift | 2 faders | 4E F7
  // Byte 23 is 0x4E on every firmware so far. A firmware that reports its mode
  // can send 0x50 ('P') there in programming mode; the page already honors it.
  // Both reply shapes land here. isExt = 37- or 55-byte extended reply, else the legacy 25-byte one.
  function parseAssignments(d) {
    var pg = state.pg, i, isExt = isExtReply(d);
    if (!isExt && pg.ext && pg.loaded) return; // already have the richer picture from this board
    clearTimeout(progTimer);
    var modeByte = d[d.length - 2];
    if (state.device) state.device.mode = modeByte === 0x50 ? 'programming' : 'unknown';
    var body = isExt ? Array.prototype.slice.call(d, 8, d.length - 2) : Array.prototype.slice.call(d, 7, 23);
    if (pg.pendingWrite) {
      var same = body.length === pg.pendingWrite.length;
      for (i = 0; same && i < body.length; i++) { if (body[i] !== pg.pendingWrite[i]) same = false; }
      clearTimeout(writeTimer); pg.pendingWrite = null;
      pg.writeResult = same ? 'saved' : 'ignored';
      log(same ? 'Read-back matches: assignments saved' : 'Read-back differs: the board ignored the write (normal mode)', same ? 'ok' : 'warn');
      if (!same) { pg.loaded = true; pg.dirty = true; render(); return; } // keep the person's edits on screen
    }
    pg.ext = isExt;
    if (isExt) {
      var flags = d[8], hasColors = !!(flags & EXT_FLAG_COLORS) && d.length === 55;
      pg.channel = d[9]; pg.shift = d[10] ? 1 : 0;
      for (i = 0; i < ORDER.length; i++) { pg.types[ORDER[i]] = d[11 + i * 2]; pg.buttons[ORDER[i]] = d[12 + i * 2]; }
      for (i = 0; i < SHIFT_ORDER.length; i++) { pg.shiftTypes[SHIFT_ORDER[i]] = d[23 + i * 2]; pg.shiftButtons[SHIFT_ORDER[i]] = d[24 + i * 2]; }
      pg.faders = [d[33], d[34]];
      pg.colors = null;
      if (hasColors) { pg.colors = {}; for (i = 0; i < ORDER.length; i++) pg.colors[ORDER[i]] = [d[35 + i * 3], d[36 + i * 3], d[37 + i * 3]]; }
      pg.type = pg.types.play;
    } else {
      pg.colors = null;
      pg.channel = d[7]; pg.type = d[8] ? 1 : 0; pg.shift = d[9] ? 1 : 0;
      for (i = 0; i < ORDER.length; i++) { pg.buttons[ORDER[i]] = d[10 + i]; pg.types[ORDER[i]] = pg.type; }
      for (i = 0; i < SHIFT_ORDER.length; i++) { pg.shiftButtons[SHIFT_ORDER[i]] = d[16 + i]; pg.shiftTypes[SHIFT_ORDER[i]] = pg.type; }
      pg.faders = [d[21], d[22]];
    }
    pg.loaded = true; pg.dirty = false;
    log((isExt ? 'Extended' : 'Legacy') + ' assignments loaded: channel ' + pg.channel + (isExt ? ', per-button types' + (pg.colors ? ', LED colors' : '') : ', ' + (pg.type ? 'CC' : 'notes')));
    render();
  }
  function buildAssignments() {
    var pg = state.pg, out = [0xF0, 0x00, 0x21, 0x6E, 0x7F, 0x00, 0x00];
    if (pg.ext) {
      out.push(0x21, EXT_FLAG_TYPES | (pg.colors ? EXT_FLAG_COLORS : 0), pg.channel, pg.shift);
      ORDER.forEach(function (k) { out.push(pg.types[k], pg.buttons[k]); });
      SHIFT_ORDER.forEach(function (k) { out.push(pg.shiftTypes[k], pg.shiftButtons[k]); });
      out.push(pg.faders[0], pg.faders[1]);
      if (pg.colors) ORDER.forEach(function (k) { var c = pg.colors[k]; out.push(c[0] & 0x7F, c[1] & 0x7F, c[2] & 0x7F); });
      out.push(0x4E, 0xF7);
    } else {
      out.push(pg.channel, pg.type, pg.shift);
      ORDER.forEach(function (k) { out.push(pg.buttons[k]); });
      SHIFT_ORDER.forEach(function (k) { out.push(pg.shiftButtons[k]); });
      out.push(pg.faders[0], pg.faders[1], 0x4E, 0xF7);
    }
    return out;
  }
  var writeTimer = null;
  function writeAssignments() {
    var bytes = buildAssignments(), pg = state.pg;
    pg.pendingWrite = pg.ext ? bytes.slice(8, bytes.length - 2) : bytes.slice(7, 23); pg.writeResult = 'pending';
    render();
    if (!state.live) return;
    sendTo(oakOutputs(), bytes, 'Assignments');
    setTimeout(function () { requestAssignments(true); }, 700);
    clearTimeout(writeTimer);
    writeTimer = setTimeout(function () {
      if (pg.writeResult === 'pending') { pg.writeResult = 'noreply'; pg.pendingWrite = null; log('No read-back after write', 'warn'); render(); }
    }, 2600);
  }
  function flash(btn) { var s = btn.querySelector('span'), t = s.textContent; s.textContent = 'Sent'; setTimeout(function () { s.textContent = t; }, 1200); }

  /* ===================================================================== */
  function pressTile(k) {
    var t = document.querySelector('.btile[data-btn="' + k + '"]'); if (!t) return;
    t.classList.add('pressed'); setTimeout(function () { t.classList.remove('pressed'); }, 220);
  }

  /* =====================================================================
     4. TAP TEMPO + METRONOME
        Two separate things. The tap tempo is the all8 method and nothing
        else: BPM = 60000 * intervals / (last tap - first tap) over the whole
        run, so every clean tap tightens the number, and a pause longer than
        the timeout starts a fresh run. Nothing runs on its own while you tap.
        The metronome only exists after Start. It takes the tempo as it
        stands (in phase with your taps if you were just tapping, otherwise
        beat 1 right now) and from then on only the Align controls, Next tap
        = 1, or typing a number can move it. Taps after Start are counted
        separately and offered, never applied.
     ===================================================================== */
  var SIGS = {
    // beats per bar, the tapped pulse in quarter notes, default subdivision, how to say the pulse
    '4/4': { beats: 4, pulse: 1, sub: 1, name: 'quarter note' }, '3/4': { beats: 3, pulse: 1, sub: 1, name: 'quarter note' },
    '2/4': { beats: 2, pulse: 1, sub: 1, name: 'quarter note' }, '5/4': { beats: 5, pulse: 1, sub: 1, name: 'quarter note' },
    '7/4': { beats: 7, pulse: 1, sub: 1, name: 'quarter note' },
    '6/8': { beats: 2, pulse: 1.5, sub: 3, name: 'dotted quarter' }, '9/8': { beats: 3, pulse: 1.5, sub: 3, name: 'dotted quarter' },
    '12/8': { beats: 4, pulse: 1.5, sub: 3, name: 'dotted quarter' },
    '7/8': { beats: 7, pulse: 0.5, sub: 1, name: 'eighth note' }, '5/8': { beats: 5, pulse: 0.5, sub: 1, name: 'eighth note' },
    '2/2': { beats: 2, pulse: 2, sub: 2, name: 'half note' }, '1/4': { beats: 1, pulse: 1, sub: 1, name: 'quarter note' }
  };
  var NOTE_VALUES = [
    { n: 'Whole', q: 4 }, { n: 'Dotted half', q: 3 }, { n: 'Half', q: 2 }, { n: 'Dotted quarter', q: 1.5 }, { n: 'Quarter', q: 1 },
    { n: 'Dotted eighth', q: 0.75 }, { n: 'Eighth', q: 0.5 }, { n: 'Triplet eighth', q: 1 / 3 }, { n: 'Sixteenth', q: 0.25 }, { n: 'Triplet sixteenth', q: 1 / 6 }
  ];
  var TT = {
    taps: [], lastTap: null, timeout: 2000, oneIndex: 0,   // oneIndex: which tap of the run is beat 1 (Next tap = 1 moves it)
    bpm: null,                                       // the tempo, exact (tapped or typed)
    running: false, anchor: null, period: null,      // metronome grid, only while running
    remarkNext: false, armed: false,                 // armed: MIDI Start waits for the next 1
    sig: '4/4', sub: 1, accent: true, sound: 'click', volume: 0.7, visual: 'dots',
    resolution: 1,
    out: '', sendClock: true, sendNote: false, inPort: '', noteNumber: 60, noteChannel: 16,
    lastBeatTime: null, lastTickTime: null,
    ramp: { step: 0, every: 4, target: null, bars: 0, lastBar: null }, quiet: 0, swing: 0, subLevel: 0.5, countIn: false, countInLeft: 0,
    runBar: null, since: null                        // since: { taps, bpm } tapped after Start, offered but not applied
  };
  var TOUCH = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
  var TT_START_EARLY = 75;   // ms. A Start press lands this much after the beat you meant, every time, at any tempo (measured by Jeff), so the grid goes that far ahead of it
  var TT_HORIZON = 120;
  var ttAudio = null, ttTimer = null;

  function ttNow() { return performance.now(); }
  function ttSig() { return SIGS[TT.sig] || SIGS['4/4']; }
  function ttShown() { if (TT.bpm == null) return null; var r = TT.resolution; return r === 'exact' ? TT.bpm : Math.round(TT.bpm / r) * r; }
  function ttQuarterBpm() { var s = ttShown(); return s == null ? null : s * ttSig().pulse; }   // what a DAW calls the tempo: a dotted-quarter pulse of 80 is 120 quarter notes a minute
  function ttFmt(b) { if (b == null) return '--'; var v = Math.round(b * 10) / 10; return (v % 1 === 0 ? v.toFixed(0) : v.toFixed(1)); }
  function ttFmt1(b) { return b == null ? '--' : (Math.round(b * 10) / 10).toString(); }
  function ttOutput() { var o = null; if (midi && TT.out) midi.outputs.forEach(function (p) { if (p.id === TT.out && p.state === 'connected') o = p; }); return o; }
  function ttBeatPos(t) { var b = ttSig().beats, k = Math.round((t - TT.anchor) / TT.period); return ((k % b) + b) % b; }
  function ttRunBpm(taps) { var n = taps.length; return n >= 2 ? 60000 * (n - 1) / (taps[n - 1] - taps[0]) : null; }
  // How sure the tapped number is: the first and last tap each carry the typical tap
  // scatter, and that is the whole error of an all8 average, so it shrinks with time.
  function ttPrecision(taps) {
    var n = taps.length; if (n < 6) return null;
    var d = [], i, mean = 0, sd = 0;
    for (i = 1; i < n; i++) d.push(taps[i] - taps[i - 1]);
    for (i = 0; i < d.length; i++) mean += d[i]; mean /= d.length;
    for (i = 0; i < d.length; i++) sd += (d[i] - mean) * (d[i] - mean); sd = Math.sqrt(sd / d.length);
    var bpm = ttRunBpm(taps), span = taps[n - 1] - taps[0];
    return bpm * (sd * Math.SQRT2) / span;
  }

  // Period follows the shown tempo. When the tempo changes on a running metronome,
  // the beat nearest to now stays where it is, so a trim never makes it stumble.
  function ttApplyTempo() {
    var shown = ttShown(); if (!shown) { TT.period = null; return; }
    var p = 60000 / shown;
    if (TT.running && TT.period && TT.anchor != null) {
      var k = Math.round((ttNow() - TT.anchor) / TT.period);
      TT.anchor = TT.anchor + k * (TT.period - p);
    }
    TT.period = p;
  }
  function ttSetBpm(v, why) {
    if (v == null || isNaN(v)) return;
    v = Math.min(300, Math.max(20, Math.round(v * 10) / 10));
    TT.bpm = v; TT.taps = []; TT.lastTap = null; TT.oneIndex = 0; TT.since = null;
    ttApplyTempo();
    log((why || 'Tempo set') + ': ' + ttFmt(ttShown()) + ' BPM');
    ttRender();
  }
  function ttTap(t, source) {
    ttEnsureAudio();
    if (TT.lastTap != null && t - TT.lastTap > TT.timeout) { TT.taps = []; TT.oneIndex = 0; if (TT.running) TT.since = null; }   // the pause ended the run
    TT.lastTap = t;
    if (TT.remarkNext) {
      TT.remarkNext = false;
      if (TT.running) {
        // Only the label moves: the beat nearest this tap becomes 1. Tempo and phase stay exactly where they are.
        var kk = Math.round((t - TT.anchor) / TT.period);
        TT.anchor += kk * TT.period; TT.runBar = null;
        log('Bar line moved: the beat nearest that tap is now 1');
      } else {
        TT.oneIndex = TT.taps.length;                    // this tap is beat 1 of the run; the tempo keeps every tap
        log('Counting from that tap as 1');
      }
    }
    TT.taps.push(t);
    ttSendTapNote(t);
    if (!TT.running) {
      var b = ttRunBpm(TT.taps);
      if (b != null) TT.bpm = Math.min(300, Math.max(20, b));   // every tap refines the number; nothing else moves
    } else {
      var rb = ttRunBpm(TT.taps);
      TT.since = rb != null ? { taps: TT.taps.length, bpm: rb } : null;   // offered on the Align row, not applied
    }
    ttFlashPad();
    ttRender();
  }
  function ttStart(pressTime) {
    ttEnsureAudio();
    if (TT.bpm == null) { TT.bpm = 120; log('No tempo yet, starting at 120 BPM'); }
    ttApplyTempo();
    // In phase with the taps if you were just tapping (the run's first tap is beat 1).
    // Otherwise beat 1 is the press itself: the first click sounds right now. Either way the
    // grid sits TT_START_EARLY ms ahead, because a press always lands a little after the beat you meant.
    var n = TT.taps.length, t0 = pressTime || ttNow(), fromTaps = n >= 2 && TT.lastTap != null && (t0 - TT.lastTap) < 4000;
    TT.running = true; TT.runBar = null; TT.since = null;
    TT.lastBeatTime = null; TT.lastTickTime = null;
    TT.ramp.bars = 0; TT.ramp.lastBar = null;
    TT.countInLeft = TT.countIn ? 1 : 0;
    if (TT.sendClock && ttOutput()) TT.armed = true;   // MIDI Start goes out on the next 1 (after the count-in, if any)
    if (fromTaps) {
      var sum = 0; for (var i = 0; i < n; i++) sum += TT.taps[i] - i * TT.period;
      TT.anchor = sum / n + Math.min(TT.oneIndex, n - 1) * TT.period - TT_START_EARLY;   // best-fit time of the tap that is beat 1, pulled ahead by the same lateness
    } else {
      TT.anchor = t0 - TT_START_EARLY;                  // beat 1 was TT_START_EARLY ms ago; the next click comes that much sooner, then it runs in time
      ttBeat(t0, 0);                                    // but beat 1 still sounds at the press
      TT.lastBeatTime = TT.anchor;                      // the scheduler carries on from beat 2
    }
    ttStartTimer();
    log('Metronome running at ' + ttFmt(ttShown()) + ' BPM, ' + TT.sig + (fromTaps ? ', in time with your taps' : '') + ', ' + TT_START_EARLY + ' ms ahead of the press' + (TT.countInLeft ? ', one bar count-in' : '') + (TT.armed ? '; MIDI Start on the 1' : ''));
    ttRender();
  }
  function ttStop(quiet) {
    var out = ttOutput();
    if (TT.running && !TT.armed && out && TT.sendClock) { try { out.send([0xFC]); } catch (e) {} if (!quiet) log('MIDI Stop sent to ' + out.name); }
    TT.running = false; TT.armed = false; TT.since = null; TT.remarkNext = false;
    TT.anchor = null; TT.lastBeatTime = null; TT.lastTickTime = null;
    ttStopTimer(); ttPulseClear();
    if (!quiet) log('Metronome stopped');
    ttRender();
  }
  function ttReset() {
    ttStop(true);
    TT.taps = []; TT.lastTap = null; TT.oneIndex = 0; TT.bpm = null; TT.period = null; TT.since = null;
    log('Tap tempo reset');
    ttRender();
  }
  function ttTrim(d) {
    if (TT.bpm == null) return;
    TT.bpm = Math.min(300, Math.max(20, Math.round((TT.bpm + d) * 10) / 10));
    TT.taps = []; TT.lastTap = null;                    // the number is yours now, not the taps'
    ttApplyTempo(); ttRender();
  }
  function ttNudge(ms) {
    if (!TT.running) return;
    TT.anchor += ms;
    log('Click nudged ' + (ms > 0 ? 'later' : 'earlier') + ' by ' + Math.abs(ms) + ' ms');
    ttRender();
  }
  function ttUseSince() {
    if (!TT.since) return;
    TT.bpm = Math.min(300, Math.max(20, TT.since.bpm));
    log('Using the tempo tapped since Start: ' + ttFmt(ttShown()) + ' BPM over ' + TT.since.taps + ' taps');
    TT.since = null; TT.taps = []; TT.lastTap = null;
    ttApplyTempo(); ttRender();
  }
  function ttSetSig(sig) {
    if (!SIGS[sig]) return;
    var oldBeats = ttSig().beats;
    TT.sig = sig; TT.sub = SIGS[sig].sub;
    if (TT.running && SIGS[sig].beats !== oldBeats) { /* keep the current beat as beat 1 of the new meter */
      var k = Math.round((ttNow() - TT.anchor) / TT.period); TT.anchor += k * TT.period; TT.lastBeatTime = null;
    }
    ttBuildDots(); ttRender();
  }

  /* ---- scheduler: a worker keeps ticking when the tab is busy or hidden ---- */
  function ttStartTimer() {
    if (ttTimer) return;
    try {
      var blob = new Blob(["var t=null;onmessage=function(e){if(e.data==='start'){if(!t)t=setInterval(function(){postMessage('tick')},25)}else{clearInterval(t);t=null}}"], { type: 'application/javascript' });
      var w = new Worker(URL.createObjectURL(blob));
      w.onmessage = ttSchedule; w.postMessage('start');
      ttTimer = { stop: function () { w.terminate(); } };
    } catch (e) {
      var id = setInterval(ttSchedule, 25);
      ttTimer = { stop: function () { clearInterval(id); } };
    }
  }
  function ttStopTimer() { if (ttTimer) { ttTimer.stop(); ttTimer = null; } }
  function ttSchedule() {
    if (!TT.running || !TT.period) return;
    var now = ttNow(), horizon = now + TT_HORIZON, P = TT.period, A = TT.anchor, beats = ttSig().beats;
    var next = TT.lastBeatTime == null ? A + Math.ceil((now - A) / P) * P : TT.lastBeatTime + P;
    next = A + Math.round((next - A) / P) * P;          // back onto the grid in case it moved
    while (next < now - 40) next += P;                  // never replay beats missed while the tab slept
    if (TT.lastBeatTime != null && next <= TT.lastBeatTime + P * 0.5) next += P;
    while (next < horizon) {
      var idx = Math.round((next - A) / P), pos = ((idx % beats) + beats) % beats;
      ttBeat(next, pos); TT.lastBeatTime = next; next += P;
    }
    var out = ttOutput();
    if (TT.sendClock && out) {
      var T = P / (24 * ttSig().pulse);                 // 24 ticks per quarter note, whatever the pulse is
      var nt = TT.lastTickTime == null ? A + Math.ceil((now - A) / T) * T : TT.lastTickTime + T;
      nt = A + Math.round((nt - A) / T) * T;
      while (nt < now - 5) nt += T;
      if (TT.lastTickTime != null && nt <= TT.lastTickTime + T * 0.5) nt += T;
      while (nt < horizon) { try { out.send([0xF8], nt); } catch (e) { break; } TT.lastTickTime = nt; nt += T; }
    }
  }
  function ttSubFrac(s) {
    // where subdivision s of TT.sub sits inside the beat, with swing pushing the off-beats late
    var f = s / TT.sub;
    if (TT.swing) { if (TT.sub === 2 && s === 1) f = 0.5 + TT.swing; else if (TT.sub === 4 && (s === 1 || s === 3)) f = s / 4 + TT.swing / 2; }
    return f;
  }
  function ttBeat(time, pos) {
    var delay = Math.max(0, time - ttNow()), P = TT.period, s, beats = ttSig().beats;
    var bar = Math.floor(Math.round((time - TT.anchor) / P) / beats);
    if (TT.runBar == null) TT.runBar = bar;
    var barsRun = bar - TT.runBar;                      // bars since Start
    var countingIn = TT.countInLeft > 0 && barsRun < TT.countInLeft;
    var quiet = !countingIn && TT.quiet > 0 && (barsRun - TT.countInLeft) % TT.quiet === TT.quiet - 1;
    if (pos === 0 && !countingIn && TT.ramp.step && TT.ramp.lastBar !== bar) {
      TT.ramp.lastBar = bar;
      if (TT.ramp.bars > 0 && TT.ramp.bars % TT.ramp.every === 0) {
        var next = ttShown() + TT.ramp.step, tgt = TT.ramp.target;
        if (tgt != null && ((TT.ramp.step > 0 && next >= tgt) || (TT.ramp.step < 0 && next <= tgt))) { next = tgt; TT.ramp.step = 0; log('Ramp reached ' + ttFmt(tgt) + ' BPM'); }
        TT.bpm = Math.min(300, Math.max(20, next)); ttApplyTempo(); P = TT.period;
        setTimeout(ttRender, delay);
      }
      TT.ramp.bars++;
    }
    if (!quiet) {
      ttClick(time, pos === 0 && TT.accent ? 'accent' : 'beat');
      for (s = 1; s < TT.sub; s++) ttClick(time + P * ttSubFrac(s), 'sub');
    }
    if (pos === 0 && TT.armed && !countingIn) {
      TT.armed = false;
      var out = ttOutput();
      if (out && TT.sendClock) { try { out.send([0xFA], Math.max(ttNow(), time - 1)); log('MIDI Start sent to ' + out.name + ' on the 1', 'ok'); } catch (e) { log('Could not send Start: ' + e.message, 'err'); } }
      setTimeout(ttRender, delay);
    }
    setTimeout(function () { ttPulse(pos, quiet, countingIn); }, delay);
    if (TT.visual === 'dots' && !quiet) for (s = 1; s < TT.sub; s++) (function (i) { setTimeout(function () { ttSubBlink(i); }, delay + P * ttSubFrac(i)); })(s);
  }

  /* ---- click (Web Audio) ---- */
  function ttEnsureAudio() {
    if (!ttAudio && (window.AudioContext || window.webkitAudioContext)) { try { ttAudio = new (window.AudioContext || window.webkitAudioContext)(); } catch (e) { ttAudio = null; } }
    if (ttAudio && ttAudio.state === 'suspended') ttAudio.resume();
  }
  function ttAudioTime(perfMs) {
    var ots = ttAudio.getOutputTimestamp ? ttAudio.getOutputTimestamp() : null;
    var t = (ots && ots.contextTime != null) ? ots.contextTime + (perfMs - ots.performanceTime) / 1000 : ttAudio.currentTime + (perfMs - performance.now()) / 1000;
    return t - (ttAudio.outputLatency || 0);
  }
  var ttNoise = null;
  function ttNoiseBuffer() {
    if (ttNoise) return ttNoise;
    var len = Math.floor(ttAudio.sampleRate * 0.05), buf = ttAudio.createBuffer(1, len, ttAudio.sampleRate), d = buf.getChannelData(0);
    for (var i = 0; i < len; i++) d[i] = Math.random() * 2 - 1;
    ttNoise = buf; return buf;
  }
  function ttClick(perfMs, kind) {
    if (!ttAudio || TT.volume <= 0) return;
    var t = Math.max(ttAudio.currentTime + 0.003, ttAudioTime(perfMs));
    var level = (kind === 'accent' ? 1 : kind === 'beat' ? 0.62 : 0.62 * TT.subLevel) * TT.volume;
    if (level <= 0.001) return;
    var g = ttAudio.createGain(); g.connect(ttAudio.destination);
    var src;
    if (TT.sound === 'wood') {
      src = ttAudio.createBufferSource(); src.buffer = ttNoiseBuffer();
      var f = ttAudio.createBiquadFilter(); f.type = 'bandpass'; f.frequency.value = kind === 'accent' ? 2400 : kind === 'beat' ? 1500 : 3200; f.Q.value = 6;
      src.connect(f); f.connect(g);
      g.gain.setValueAtTime(level * 1.6, t); g.gain.exponentialRampToValueAtTime(0.0001, t + (kind === 'sub' ? 0.02 : 0.045));
      src.start(t); src.stop(t + 0.06);
    } else {
      src = ttAudio.createOscillator();
      src.type = TT.sound === 'beep' ? 'square' : 'sine';
      src.frequency.value = kind === 'accent' ? (TT.sound === 'beep' ? 1320 : 1760) : kind === 'beat' ? (TT.sound === 'beep' ? 880 : 1175) : (TT.sound === 'beep' ? 660 : 880);
      src.connect(g);
      g.gain.setValueAtTime(0.0001, t);
      g.gain.exponentialRampToValueAtTime(level * (TT.sound === 'beep' ? 0.35 : 0.9), t + 0.002);
      g.gain.exponentialRampToValueAtTime(0.0001, t + (kind === 'accent' ? 0.07 : kind === 'beat' ? 0.045 : 0.03));
      src.start(t); src.stop(t + 0.09);
    }
  }
  function ttSendTapNote(t) {
    var out = ttOutput(); if (!out || !TT.sendNote) return;
    var ch = (TT.noteChannel - 1) & 0x0F;
    try { out.send([0x90 | ch, TT.noteNumber, 100]); out.send([0x80 | ch, TT.noteNumber, 0], ttNow() + 40); } catch (e) {}
  }

  /* ---- visuals ---- */
  var pendSide = -1;
  function ttBuildDots() {
    var wrap = $('beatDots'), beats = ttSig().beats, html = '';
    for (var i = 0; i < beats; i++) html += '<i></i>';
    wrap.innerHTML = html;
  }
  function ttPulse(pos, quiet, countingIn) {
    var ring = $('tapRing'), pad = $('tapPad');
    pad.classList.toggle('quiet', !!quiet);
    if (TT.running) $('tapState').textContent = countingIn ? 'Count-in' : quiet ? 'Quiet bar' : 'Running';
    ring.classList.add('beat'); if (pos === 0) ring.classList.add('one');
    setTimeout(function () { ring.classList.remove('beat'); ring.classList.remove('one'); }, 90);
    var dots = $('beatDots').children;
    for (var i = 0; i < dots.length; i++) dots[i].className = i === pos ? 'on' : '';
    if (TT.visual === 'pendulum') {
      var pend = $('pendulum'), arm = $('pendArm');
      pendSide = -pendSide;
      pend.classList.remove('stopped');
      if (pos === 0) pend.classList.add('one'); else pend.classList.remove('one');
      arm.style.transitionDuration = Math.max(80, TT.period || 500) + 'ms';
      arm.style.transform = 'rotate(' + (pendSide * 24) + 'deg)';
    }
  }
  function ttSubBlink(i) {
    var dots = $('beatDots').children;
    for (var k = 0; k < dots.length; k++) if (dots[k].className === 'on') { dots[k].className = 'on dim'; setTimeout((function (el) { return function () { if (el.className === 'on dim') el.className = 'on'; }; })(dots[k]), 40); }
  }
  function ttPulseClear() {
    var dots = $('beatDots').children;
    for (var i = 0; i < dots.length; i++) dots[i].className = '';
    var pend = $('pendulum'); pend.classList.add('stopped'); pend.classList.remove('one');
    $('tapPad').classList.remove('quiet');
  }
  function ttFlashPad() {
    var pad = $('tapPad'); pad.classList.add('hit');
    setTimeout(function () { pad.classList.remove('hit'); }, 70);
    if (TT.running && TT.period) $('tapPadSub').textContent = 'That tap landed on ' + (ttBeatPos(TT.lastTap) + 1);
  }
  function pressFlash(el) { if (!el) return; el.classList.add('pressed'); setTimeout(function () { el.classList.remove('pressed'); }, 110); }
  function segStr(el, v) { Array.prototype.forEach.call(el.querySelectorAll('button'), function (b) { b.setAttribute('aria-pressed', String(b.dataset.v === String(v))); }); }
  function ttPorts() {
    var outSel = $('tapOut'), inSel = $('tapIn');
    var keepOut = TT.out, keepIn = TT.inPort;
    outSel.innerHTML = '<option value="">Nowhere (screen and click only)</option>';
    inSel.innerHTML = '<option value="">This screen and the keyboard</option>';
    if (midi) {
      midi.outputs.forEach(function (p) { if (p.state !== 'connected') return; var o = document.createElement('option'); o.value = p.id; o.textContent = p.name; outSel.appendChild(o); });
      midi.inputs.forEach(function (p) { if (p.state !== 'connected') return; var o = document.createElement('option'); o.value = p.id; o.textContent = p.name; inSel.appendChild(o); });
    }
    outSel.value = keepOut; if (outSel.value !== keepOut) { TT.out = ''; outSel.value = ''; }
    inSel.value = keepIn; if (inSel.value !== keepIn) { TT.inPort = ''; inSel.value = ''; }
  }
  function ttShareLink() {
    var q = [];
    if (ttShown() != null) q.push('bpm=' + encodeURIComponent(ttFmt(ttShown())));
    q.push('sig=' + encodeURIComponent(TT.sig));
    if (TT.sub > 1) q.push('sub=' + TT.sub);
    return location.origin + location.pathname + '?' + q.join('&') + '#tap';
  }
  function ttApplyUrl() {
    var m, qs = location.search || '';
    if (!/[?&](bpm|sig|sub)=/.test(qs) && location.hash !== '#tap') return;
    if ((m = /[?&]sig=([^&]+)/.exec(qs))) { var sig = decodeURIComponent(m[1]); if (SIGS[sig]) { TT.sig = sig; TT.sub = SIGS[sig].sub; } }
    if ((m = /[?&]sub=(\d)/.exec(qs)) && +m[1] >= 1 && +m[1] <= 4) TT.sub = +m[1];
    if ((m = /[?&]bpm=([\d.]+)/.exec(qs))) { var v = parseFloat(m[1]); if (!isNaN(v)) TT.bpm = Math.min(300, Math.max(20, Math.round(v * 10) / 10)); }
    selectTool('tap');
    ttBuildDots();
    log('Opened from a link: ' + (TT.bpm ? ttFmt(ttShown()) + ' BPM, ' : '') + TT.sig);
  }
  function ttRenderValues() {
    var q = ttQuarterBpm(), sig = ttSig(), shown = ttShown();
    var note = $('tapValuesNote'), grid = $('tapValuesGrid');
    if (q == null) { note.textContent = 'Tap or type a tempo to fill this in.'; grid.innerHTML = ''; return; }
    var txt = '';
    if (sig.pulse !== 1) {
      txt = 'In ' + TT.sig + ' you tap the ' + sig.name + ' at <b>' + ttFmt(shown) + '</b>. ' +
        (sig.pulse === 1.5 ? 'Eighth notes run at <b>' + ttFmt(shown * 3) + '</b>, and the quarter-note tempo a DAW wants is <b>' + ttFmt1(q) + '</b>.'
          : 'The quarter-note tempo a DAW wants is <b>' + ttFmt1(q) + '</b>.');
    } else txt = 'At <b>' + ttFmt(shown) + '</b> BPM. Delay times for pedals and plug-ins.';
    note.innerHTML = txt;
    var html = '';
    NOTE_VALUES.forEach(function (v) {
      var bpm = q / v.q, ms = 60000 / q * v.q;
      html += '<div><span class="n">' + v.n + '</span><span class="b">' + ttFmt1(bpm) + '<small>BPM</small></span><span class="ms">' + Math.round(ms) + ' ms</span></div>';
    });
    grid.innerHTML = html;
  }
  function ttRender() {
    var ring = $('tapRing'), shown = ttShown(), n = TT.taps.length, banner = $('tapBanner'), sig = ttSig();
    var tapping = !TT.running && n > 0;
    ring.className = 'ring ' + (TT.running ? 'locked' : tapping ? 'tapping' : 'none');
    var bpmBtn = $('tapBpm'), txt = shown != null ? ttFmt(shown) : '--';
    bpmBtn.className = 'ver bpm' + (txt.length > 3 ? ' long' : '');
    bpmBtn.innerHTML = shown != null ? txt + '<small>BPM</small>' : '--';
    $('tapRingLabel').textContent = sig.pulse === 1 ? 'Tempo' : sig.name + 's';
    $('tapState').textContent = TT.running ? 'Running' : tapping ? 'Tapping' : shown != null ? 'Ready' : 'Tap along';
    var prec = !TT.running ? ttPrecision(TT.taps) : null;
    var span = n >= 2 ? (TT.taps[n - 1] - TT.taps[0]) / 1000 : 0;
    var exact = (!TT.running && n >= 2 && TT.resolution !== 'exact' && TT.bpm != null) ? ', ' + (Math.round(TT.bpm * 10) / 10).toFixed(1) + ' exact' : '';
    $('tapCount').textContent = n ? (n + (span >= 1 ? ' over ' + (span < 10 ? span.toFixed(1) : Math.round(span)) + ' s' : '') + exact) : '0';
    $('tapPrecision').textContent = prec != null ? '±' + (prec < 0.05 ? '0.05' : prec.toFixed(prec < 1 ? 1 : 0)) + ' BPM' : (tapping && n < 6 ? 'Keep tapping' : '--');
    var half = $('tapHalf'), dbl = $('tapDouble');
    half.textContent = shown != null ? ttFmt(shown / 2) : '--'; dbl.textContent = shown != null ? ttFmt(shown * 2) : '--';
    half.disabled = shown == null || shown / 2 < 20; dbl.disabled = shown == null || shown * 2 > 300;
    var start = $('tapStart');
    start.disabled = TT.running;
    start.className = 'tbtn block' + (TT.running ? ' running' : ' glow');
    start.querySelector('span').textContent = TT.running ? 'Running' : 'Start';
    $('tapStop').disabled = !TT.running;
    $('tapReset').disabled = !n && TT.bpm == null && !TT.running;
    $('tapRemark').className = 'tbtn block' + (TT.remarkNext ? ' wait' : '');
    $('tapRemark').querySelector('span').textContent = TT.remarkNext ? 'Tap the 1 now' : 'Next tap = 1';
    $('tapPad').className = 'tap-pad' + (TT.running ? ' locked' : '');
    if (!TT.running) $('tapPadSub').textContent = n ? 'Keep going, every tap tightens it' : (TOUCH ? 'Tap here along with the music' : 'Space bar, click, or a MIDI note');
    $('tapAlign').hidden = !TT.running;
    $('tapSince').textContent = TT.since ? ttFmt(TT.since.bpm) + ' BPM over ' + TT.since.taps + ' taps' : '--';
    $('tapUse').hidden = !TT.since || TT.since.taps < 4;
    $('tapSig').value = TT.sig;
    segStr($('tapSub'), TT.sub); seg($('tapAccent'), TT.accent ? 1 : 0); segStr($('tapSound'), TT.sound); segStr($('tapVisual'), TT.visual);
    $('beatDots').hidden = TT.visual !== 'dots'; $('pendulum').hidden = TT.visual !== 'pendulum';
    segStr($('tapRes'), TT.resolution); segStr($('tapTimeout'), TT.timeout);
    $('tapRampStep').value = String(TT.ramp.step); $('tapRampEvery').value = String(TT.ramp.every);
    if (document.activeElement !== $('tapRampTarget')) $('tapRampTarget').value = TT.ramp.target != null ? TT.ramp.target : '';
    segStr($('tapQuiet'), TT.quiet); segStr($('tapSwing'), TT.swing); seg($('tapCountIn'), TT.countIn ? 1 : 0);
    $('tapSendClock').setAttribute('aria-pressed', String(TT.sendClock));
    $('tapSendNote').setAttribute('aria-pressed', String(TT.sendNote));
    ttRenderValues();
    var info = '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M12 8v5M12 16h.01"/></svg>';
    var tick = '<svg viewBox="0 0 24 24"><path d="M5 12l4 4L19 6"/></svg>';
    banner.className = 'banner';
    if (TT.running) {
      banner.classList.add('ok');
      banner.innerHTML = tick + '<div class="bt"><b>Metronome running at ' + ttFmt(shown) + ' BPM in ' + TT.sig + '. Nothing moves it but you.</b><span>Line it up with the music using the tempo and nudge buttons below. If the bar line is off, press <kbd>NEXT TAP = 1</kbd> and tap the 1. Taps are still counted, and offered as a number, never applied on their own.</span></div>';
    } else if (tapping) {
      banner.classList.add('standby');
      banner.innerHTML = info + '<div class="bt"><b>Tapping. Every tap tightens the number.</b><span>The tempo is the average of the whole run, first tap to last, so thirty seconds of clean taps gets you within a tenth of a BPM. A pause longer than ' + (TT.timeout / 1000) + ' s starts a fresh run. When it reads right, <kbd>START</kbd>.</span></div>';
    } else if (shown != null) {
      banner.innerHTML = info + '<div class="bt"><b>Ready at ' + ttFmt(shown) + ' BPM.</b><span><kbd>START</kbd> runs the metronome from beat 1. Tap again to measure a new tempo, or click the number to type one.</span></div>';
    } else {
      banner.innerHTML = info + '<div class="bt"><b>Tap the beat along with the music.</b><span>Keep tapping and watch the number settle; the precision readout on the left tells you how close it is. Or click the number and type a tempo. Nothing runs until you press <kbd>START</kbd>.</span></div>';
    }
  }

  /* =====================================================================
     5. WIRING
     ===================================================================== */
  function selectTool(tool) {
    state.tool = tool;
    Array.prototype.forEach.call(document.querySelectorAll('.tool-tab'), function (t) {
      t.setAttribute('aria-selected', String(t.dataset.tool === tool));
      if (t.dataset.tool === tool && t.scrollIntoView) { try { t.scrollIntoView({ inline: 'center', block: 'nearest' }); } catch (e) {} }   // on a phone the rail scrolls sideways; keep the active tab in view
    });
    ['firmware', 'programmer', 'monitor', 'tap'].forEach(function (p) { $('panel-' + p).hidden = p !== tool; });
    // The tap tempo needs no Oakboard and no Web MIDI, so the device strip and the browser note step aside for it
    $('deviceStrip').hidden = tool === 'tap';
    $('browserNote').hidden = tool === 'tap';
    if (tool === 'tap') ttEnsureAudio();   // warm the audio engine now, so the first Start doesn't pay for it
  }
  document.querySelector('.tool-tabs').addEventListener('click', function (e) {
    var t = e.target.closest('.tool-tab'); if (t) selectTool(t.dataset.tool);
  });
  $('scanBtn').addEventListener('click', scan);
  $('todo').addEventListener('click', function (e) { if (e.target.closest('#libRetry')) { loadLibrary(); render(); } });
  $('todo').addEventListener('submit', function (e) {
    var f = e.target; if (!f || f.id !== 'manualForm') return;
    e.preventDefault();
    var model = f.elements.model.value, raw = f.elements.version.value.trim();
    state.manual.model = model; state.manual.version = raw;
    var v = parseVersion(raw);
    if (!v) { state.manual.error = 'Versions look like 1.9.4 or 2.0.1'; renderFirmware(); var inp = document.querySelector('#manualForm [name=version]'); if (inp) inp.focus(); return; }
    state.manual.error = '';
    clearTimeout(scanTimer);
    state.scanning = false;
    state.device = { model: model, version: vstr(v), port: 'Typed by hand', mode: 'normal', identified: true, manual: true };
    state.pg.loaded = false; state.pg.dirty = false;
    log('Typed by hand: ' + MODELS[model].name + ' ' + vstr(v));
    render();
  });

  $('pgModel').addEventListener('change', function () { state.pg.model = this.value; renderProgrammer(); });
  function touched() { state.pg.dirty = true; if (state.pg.writeResult !== 'pending') state.pg.writeResult = ''; }
  $('pgChannel').addEventListener('change', function () { state.pg.channel = +this.value; touched(); renderProgrammer(); });
  $('pgType').addEventListener('click', function (e) {
    var b = e.target.closest('button'); if (!b) return;
    var v = +b.dataset.v, pg = state.pg;
    if (pg.ext) { Object.keys(pg.types).forEach(function (k) { pg.types[k] = v; }); Object.keys(pg.shiftTypes).forEach(function (k) { pg.shiftTypes[k] = v; }); }
    else pg.type = v;
    touched(); renderProgrammer();
  });
  $('pgShift').addEventListener('click', function (e) { var b = e.target.closest('button'); if (!b) return; state.pg.shift = +b.dataset.v; touched(); renderProgrammer(); });
  $('board').addEventListener('change', function (e) {
    var s = e.target; if (s.tagName !== 'SELECT') return;
    var id = s.id, v = +s.value, pg = state.pg;
    if (id.indexOf('t-b-') === 0) pg.types[id.slice(4)] = v;
    else if (id.indexOf('t-s-') === 0) pg.shiftTypes[id.slice(4)] = v;
    else if (id.indexOf('b-') === 0) pg.buttons[id.slice(2)] = v;
    else if (id.indexOf('s-') === 0) pg.shiftButtons[id.slice(2)] = v;
    else if (id.indexOf('f-') === 0) pg.faders[+id.slice(2)] = v;
    touched(); renderProgrammer();
  });
  // LED color popover: presets plus a native picker for anything else
  function closeLedPop() { var p = document.querySelector('.led-pop'); if (p) p.remove(); }
  $('board').addEventListener('click', function (e) {
    var sw = e.target.closest('.swatch');
    var pop = e.target.closest('.led-pop');
    if (!sw && !pop) { closeLedPop(); return; }
    if (sw) {
      var key = sw.dataset.swatch, cur = state.pg.colors[key];
      var open = document.querySelector('.led-pop[data-for="' + key + '"]');
      closeLedPop(); if (open) return;
      var html = '<div class="led-pop" data-for="' + key + '"><div class="led-row">' +
        LED_PRESETS.map(function (p) { return '<button type="button" class="led-dot' + (rgbHex(p.rgb) === rgbHex(cur) ? ' on' : '') + '" data-rgb="' + p.rgb.join(',') + '" title="' + p.name + '" style="--dot:' + rgbCss(p.rgb, 1) + '"' + (p.name === 'Off' ? ' data-off="1"' : '') + '></button>'; }).join('') +
        '</div><label class="led-custom">Custom <input type="color" value="' + rgbHex(cur) + '"></label></div>';
      sw.closest('.btile').insertAdjacentHTML('beforeend', html);
      return;
    }
    var dot = e.target.closest('.led-dot');
    if (dot) {
      var key2 = pop.dataset.for; state.pg.colors[key2] = dot.dataset.rgb.split(',').map(Number);
      touched(); renderProgrammer();
    }
  });
  $('board').addEventListener('input', function (e) {
    var inp = e.target; if (inp.type !== 'color') return;
    var key = inp.closest('.led-pop').dataset.for; state.pg.colors[key] = hexRgb(inp.value);
    touched();
    var t = document.querySelector('.btile[data-btn="' + key + '"]');
    if (t) { var c = state.pg.colors[key]; t.style.setProperty('--led', rgbCss(c, 1)); t.style.setProperty('--led-line', rgbCss(c, .55)); t.style.setProperty('--led-soft', rgbCss(c, .18)); }
    $('pgWrite').className = 'tbtn block glow';
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLedPop(); });
  document.addEventListener('click', function (e) { if (!e.target.closest('.led-pop') && !e.target.closest('.swatch')) closeLedPop(); });
  $('pgRead').addEventListener('click', function () { requestAssignments(false); });
  $('pgWrite').addEventListener('click', writeAssignments);

  $('monFilters').addEventListener('click', function (e) {
    var b = e.target.closest('button'); if (!b || !b.dataset.f) return;
    var on = b.getAttribute('aria-pressed') !== 'true';
    b.setAttribute('aria-pressed', String(on)); state.mon.filters[b.dataset.f] = on;
  });
  $('monPause').addEventListener('click', function () {
    state.mon.paused = !state.mon.paused; this.textContent = state.mon.paused ? 'Resume' : 'Pause'; this.setAttribute('aria-pressed', String(state.mon.paused)); updateCount();
  });
  $('monClear').addEventListener('click', function () {
    $('logBody').innerHTML = '<div class="log-empty">Cleared. Press a button or move a fader on any connected device</div>';
    state.mon.count = 0; updateCount();
    $('lastType').className = 'type idle'; $('lastType').textContent = 'Waiting'; $('lastDetail').innerHTML = 'for MIDI<small>any port</small>';
  });

  $('connCopy').addEventListener('click', function () {
    var btn = this, text = Array.prototype.map.call($('connBody').children, function (r) { return r.textContent; }).join('\n');
    var done = function (ok) { btn.textContent = ok ? 'Copied' : 'Select and copy'; setTimeout(function () { btn.textContent = 'Copy log'; }, 1500); };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).then(function () { done(true); }, function () { done(false); });
    else done(false);
  });
  /* ---- Tap Tempo + Metronome ---- */
  $('tapPad').addEventListener('pointerdown', function (e) { if (e.button) return; e.preventDefault(); ttTap(e.timeStamp || ttNow(), 'pad'); });
  $('tapPad').addEventListener('click', function (e) { e.preventDefault(); }); // taps come from pointerdown, so keyboard activation can't double count
  document.addEventListener('keydown', function (e) {
    if (state.tool !== 'tap' || e.repeat) return;
    var tag = (e.target && e.target.tagName) || '';
    if (/INPUT|SELECT|TEXTAREA/.test(tag)) return;
    if (e.key === ' ' || e.key === 't' || e.key === 'T') { e.preventDefault(); ttTap(e.timeStamp || ttNow(), 'key'); }
    else if (e.key === 'Enter') { e.preventDefault(); if (TT.running) ttStop(false); else ttStart(e.timeStamp || ttNow()); }
    else if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); ttTrim((e.key === 'ArrowUp' ? 1 : -1) * (e.shiftKey ? 0.5 : 1)); }
    else if (TT.running && (e.key === 'ArrowLeft' || e.key === 'ArrowRight')) { e.preventDefault(); ttNudge(e.key === 'ArrowRight' ? 25 : -25); }
  });
  // Type a tempo straight into the ring
  function ttOpenBpmEdit() {
    var inp = $('tapBpmEdit'), btn = $('tapBpm');
    inp.value = ttShown() != null ? ttFmt(ttShown()) : '';
    btn.hidden = true; inp.hidden = false; inp.focus(); inp.select();
  }
  function ttCloseBpmEdit(apply) {
    var inp = $('tapBpmEdit'), btn = $('tapBpm');
    if (inp.hidden) return;
    var v = parseFloat(inp.value);
    inp.hidden = true; btn.hidden = false;
    if (apply && !isNaN(v)) ttSetBpm(v, 'Typed'); else ttRender();
  }
  $('tapBpm').addEventListener('click', ttOpenBpmEdit);
  $('tapBpmEdit').addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); ttCloseBpmEdit(true); } else if (e.key === 'Escape') { e.preventDefault(); ttCloseBpmEdit(false); } });
  $('tapBpmEdit').addEventListener('blur', function () { ttCloseBpmEdit(true); });
  $('tapStart').addEventListener('pointerdown', function (e) { if (e.button || this.disabled) return; e.preventDefault(); pressFlash(this); ttStart(e.timeStamp || ttNow()); });
  $('tapStart').addEventListener('click', function (e) { e.preventDefault(); }); // handled on pointerdown so the press, not the release, is the beat
  $('tapStop').addEventListener('click', function () { pressFlash(this); ttStop(false); });
  $('tapReset').addEventListener('click', function () { pressFlash(this); ttReset(); });
  $('tapRemark').addEventListener('click', function () { pressFlash(this); TT.remarkNext = !TT.remarkNext; ttRender(); });
  $('tapHalf').addEventListener('click', function () { var s = ttShown(); if (s != null) ttSetBpm(s / 2, 'Half time'); });
  $('tapDouble').addEventListener('click', function () { var s = ttShown(); if (s != null) ttSetBpm(s * 2, 'Double time'); });
  $('tapSig').addEventListener('change', function () { ttSetSig(this.value); log('Time signature ' + this.value + ': tap the ' + ttSig().name); });
  $('tapSub').addEventListener('click', function (e) { var b = e.target.closest('button'); if (!b) return; TT.sub = +b.dataset.v; ttRender(); });
  $('tapAccent').addEventListener('click', function (e) { var b = e.target.closest('button'); if (!b) return; TT.accent = +b.dataset.v === 1; ttRender(); });
  $('tapSound').addEventListener('click', function (e) { var b = e.target.closest('button'); if (!b) return; TT.sound = b.dataset.v; ttEnsureAudio(); if (ttAudio) ttClick(ttNow() + 20, 'beat'); ttRender(); });
  $('tapVisual').addEventListener('click', function (e) { var b = e.target.closest('button'); if (!b) return; TT.visual = b.dataset.v; ttPulseClear(); ttRender(); });
  $('tapVol').addEventListener('input', function () { TT.volume = +this.value / 100; });
  $('tapVol').addEventListener('change', function () { ttEnsureAudio(); if (ttAudio) ttClick(ttNow() + 20, 'beat'); });
  $('tapTrim').addEventListener('click', function (e) { var b = e.target.closest('button'); if (!b) return; pressFlash(b); ttTrim(+b.dataset.d); });
  $('tapNudge').addEventListener('click', function (e) { var b = e.target.closest('button'); if (!b) return; pressFlash(b); ttNudge(+b.dataset.d); });
  $('tapUse').addEventListener('click', function () { ttUseSince(); });
  $('tapRes').addEventListener('click', function (e) { var b = e.target.closest('button'); if (!b) return; TT.resolution = b.dataset.v === 'exact' ? 'exact' : +b.dataset.v; ttApplyTempo(); ttRender(); });
  $('tapTimeout').addEventListener('click', function (e) { var b = e.target.closest('button'); if (!b) return; TT.timeout = +b.dataset.v; ttRender(); });
  $('tapOut').addEventListener('change', function () { TT.out = this.value; TT.lastTickTime = null; log(TT.out ? 'Tap tempo sends to ' + this.options[this.selectedIndex].text : 'Tap tempo sends nowhere'); ttRender(); });
  $('tapIn').addEventListener('change', function () { TT.inPort = this.value; log(TT.inPort ? 'Taps also come from ' + this.options[this.selectedIndex].text + ', any note' : 'Taps come from this screen and the keyboard'); });
  $('tapSendClock').addEventListener('click', function () { TT.sendClock = !TT.sendClock; TT.lastTickTime = null; ttRender(); });
  $('tapSendNote').addEventListener('click', function () { TT.sendNote = !TT.sendNote; ttRender(); });
  // Practice panel
  $('tapRampStep').addEventListener('change', function () { TT.ramp.step = +this.value; TT.ramp.bars = 0; TT.ramp.lastBar = null; log(TT.ramp.step ? 'Tempo ramp: ' + (TT.ramp.step > 0 ? '+' : '') + TT.ramp.step + ' BPM every ' + TT.ramp.every + ' bar' + (TT.ramp.every > 1 ? 's' : '') : 'Tempo ramp off'); ttRender(); });
  $('tapRampEvery').addEventListener('change', function () { TT.ramp.every = +this.value; TT.ramp.bars = 0; ttRender(); });
  $('tapRampTarget').addEventListener('change', function () { var v = parseFloat(this.value); TT.ramp.target = isNaN(v) ? null : Math.min(300, Math.max(20, Math.round(v))); ttRender(); });
  $('tapQuiet').addEventListener('click', function (e) { var b = e.target.closest('button'); if (!b) return; TT.quiet = +b.dataset.v; ttRender(); });
  $('tapSwing').addEventListener('click', function (e) { var b = e.target.closest('button'); if (!b) return; TT.swing = +b.dataset.v; ttRender(); });
  $('tapSubLevel').addEventListener('input', function () { TT.subLevel = +this.value / 100; });
  $('tapCountIn').addEventListener('click', function (e) { var b = e.target.closest('button'); if (!b) return; TT.countIn = +b.dataset.v === 1; ttRender(); });
  $('tapShare').addEventListener('click', function () {
    var btn = this, url = ttShareLink();
    var done = function (ok) { btn.textContent = ok ? 'Copied' : url; setTimeout(function () { btn.textContent = 'Copy a link to this tempo'; }, ok ? 1500 : 6000); };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(function () { done(true); }, function () { done(false); }); else done(false);
  });
  ttBuildDots();

  // Boot: load the release list and ask for MIDI. Both render as they land.
  log(PAGE_NAME + ' starting');
  render(); ttRender();
  ttApplyUrl(); ttRender();
  loadLibrary().then(function () { render(); });
  initMIDI().then(function (ok) {
    render();
    if (ok) scan();
  });
})();
